class Common
{
    /**
     * Je bod point uvnitř kruhu se středem center a poloměrem radius?
     *
     * @param {THREE.Vector2} point
     * @param {THREE.Vector2} center
     * @param {number}        radius
     *
     * @returns {boolean}
     */
    static isPointInsideCircle(point, center, radius) {
        let dx = Math.abs(point.x - center.x);
        let dy = Math.abs(point.y - center.y);

        if (dx + dy <= radius) {
            return true;
        }
        if (dx > radius || dy > radius) {
            return false;
        }

        return (dx * dx + dy * dy <= radius * radius);
    }
}
const MOUSE_CLICK_TIMEOUT = 150;

class Mouse
{
    /**
     * Constructor
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        /** @type {HTMLElement} */
        this.container = container;

        /** @type {THREE.Vector2} */
        this.coordinates = new THREE.Vector2();

        /** @type {boolean} */
        this.mouseMoved = false;

        /** @type {number} */
        this.mouseClickedBtn = null;

        /** @type {number} */
        this.mouseDownedBtn = null;


        this.container.addEventListener('mousemove', this._callbackMouseMove.bind(this));
        this.container.addEventListener('mousedown', this._callbackMouseDown.bind(this));
        this.container.addEventListener('mouseup', this._callbackMouseUp.bind(this));
    }

    /**
     * @returns {THREE.Vector2}
     */
    getCoordinates() {
        return this.coordinates;
    }

    /**
     * @returns {boolean}
     */
    moved() {
        let tmp = this.mouseMoved;
        this.mouseMoved = false;
        return tmp;
    }

    /**
     * @param {number} button
     *
     * @returns {boolean}
     */
    clicked(button) {
        let tmp = (this.mouseClickedBtn === button);
        this.mouseClickedBtn = null;
        return tmp;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _updateCoordinates(event) {
        let offset = this.container.getBoundingClientRect();
        this.coordinates.x =  ((event.clientX - offset.left) / offset.width) * 2 - 1;
        this.coordinates.y = -((event.clientY - offset.top) / offset.height) * 2 + 1;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _callbackMouseMove(event) {
        this._updateCoordinates(event);
        this.mouseMoved = true;
    }

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _callbackMouseDown(event) {
        this._updateCoordinates(event);
        this.mouseDownedBtn = event.button;
        setTimeout(this._callbackMouseClickTimeout.bind(this), MOUSE_CLICK_TIMEOUT);
    }

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _callbackMouseUp(event) {
        this._updateCoordinates(event);
        if (this.mouseDownedBtn === event.button) {
            this.mouseClickedBtn = event.button;
        }
    }

    /**
     * @private
     */
    _callbackMouseClickTimeout() {
        this.mouseDownedBtn = null;
    }
}
const ID_MODEL_COMPASS = 'model-compass';

class Compass
{
    /**
     * Constructor
     *
     * @param {THREE.Vector3}           north
     * @param {THREE.PerspectiveCamera} camera
     */
    constructor(north, camera) {
        /** @type {THREE.Vector3} */
        this.north = north.normalize();

        /** @type {number} */
        this.angleToNorth = THREE.Math.radToDeg(this.north.angleTo(new THREE.Vector3(0, 0, 1)));

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {THREE.Spherical} */
        this.sphCoords = new THREE.Spherical();

        /** @type {HTMLElement} */
        this.element = document.getElementById(ID_MODEL_COMPASS);
    }

    update() {
        let dir = new THREE.Vector3;
        this.camera.getWorldDirection(dir);

        this.sphCoords.setFromVector3(dir);
        let angle = THREE.Math.radToDeg(this.sphCoords.theta) - this.angleToNorth;

        this.element.style.transform = `rotate(${angle}deg)`;
    }
}
/* global THREE, TWEEN */

/**
 * Karta (popisek)
 */
class Card
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     */
    constructor(container, camera) {
        /** @type {HTMLElement} */
        this.container = container;

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {Element} */
        this.element = null;
    }

    show() {
        this.element.style.display = 'block';
    }

    hide() {
        this.element.style.display = 'none';
    }

    /**
     * @param {THREE.Vector3} position
     */
    updatePosition(position) {
        let coords = position.clone().project(this.camera);
        this._updatePosition(coords);
    }

    /**
     * @param {{}} data
     */
    updateData(data = {}) {}


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {THREE.Vector3} coords
     *
     * @protected
     */
    _updatePosition(coords) {
        let x = Math.round((0.5 + coords.x * 0.5) * (this.container.clientWidth) + this.container.offsetLeft);
        this.element.style.left = `${x}px`;

        let y = Math.round((0.5 - coords.y * 0.5) * (this.container.clientHeight) + this.container.offsetTop);
        this.element.style.top = `${y}px`;
    }
}
const CLASS_MODEL_CARD_FLAT = 'js-model-card-flat';
const CLASS_NAME = 'js-name';
const CLASS_TYPE = 'js-type';
const CLASS_DISPOSITION = 'js-disposition';
const CLASS_AREA = 'js-area';
const CLASS_STATUS = 'js-status';

class CardFlat extends Card
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     */
    constructor(container, camera) {
        super(container, camera);

        this.element = document.querySelector('.' + CLASS_MODEL_CARD_FLAT);
    }

    /**
     * @param {{}} data
     */
    updateData(data) {
        let element;

        element = this.element.querySelector('.' + CLASS_NAME);
        if (element) {
            element.textContent = data.name;
        }

        element = this.element.querySelector('.' + CLASS_TYPE);
        if (element) {
            element.textContent = data.typeFormatted;
        }

        element = this.element.querySelector('.' + CLASS_DISPOSITION);
        if (element) {
            element.textContent = data.disposition;
            element.style.display = (data.disposition && data.type !== 5) ? 'block' : 'none';
        }

        element = this.element.querySelector('.' + CLASS_AREA);
        if (element) {
            element.textContent = data.areaFormatted;
            element.style.display = data.area ? 'block' : 'none';
        }

        element = this.element.querySelector('.' + CLASS_STATUS);
        if (element) {
            element.textContent = data.statusFormatted;
        }
    }
}
const CLASS_MODEL_CARD_FLOOR = 'js-model-card-floor';
const CLASS_FLOOR_NO = 'js-floor-no';

class CardFloor extends Card
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {number}                  floorNo
     */
    constructor(container, camera, floorNo) {
        super(container, camera);
        this.element = document.querySelector('.' + CLASS_MODEL_CARD_FLOOR);

        /** @type {number} */
        this.floorNo = floorNo;
    }

    /**
     * @param {{}} data
     */
    updateData(data = {}) {
        let element = this.element.querySelector('.' + CLASS_FLOOR_NO);
        if (element) {
            element.textContent = String(this.floorNo);
        }
    }
}
const CLASS_MODEL_CARD_FLOOR_STATIC = 'js-model-card-floor-static';

class CardFloorStatic extends Card
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.OrbitControls}     controls
     * @param {number}                  floorNo
     * @param {THREE.Vector3}           position
     */
    constructor(container, camera, controls, floorNo, position) {
        super(container, camera);
        this.element = document.querySelector('.' + CLASS_MODEL_CARD_FLOOR_STATIC);

        /** @type {THREE.OrbitControls} */
        this.controls = controls;
        this.controls.addEventListener('change', this._callbackControlsChanged.bind(this));

        /** @type {number} */
        this.floorNo = floorNo;

        /** @type {THREE.Vector3} */
        this.position = position;

        /** @type {boolean} */
        this.visible = false;
    }

    show() {
        this.updateData();
        this.visible = true;
        super.show();
    }

    hide() {
        this.visible = false;
        super.hide();
    }

    /**
     * @param {{}} data
     */
    updateData(data = {}) {
        let element = this.element.querySelector('.' + CLASS_FLOOR_NO);
        if (element) {
            element.textContent = String(this.floorNo);
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * Callback události: controls changed
     *
     * @param {{}} event
     *
     * @protected
     */
    _callbackControlsChanged(event) {
        if (!this.visible) {
            return;
        }

        let coords = this.position.clone().project(this.camera);
        this._updatePosition(coords);
    }
}
class SubObj
{
    /**
     * Constructor
     *
     * @param {THREE.Object3D} object
     */
    constructor(object) {
        /** @type {THREE.Object3D} */
        this.object = object;

        /** @type {THREE.Material} */
        this.material = null;

        /** @type {{}} */
        this.materials = {};


        this._initMaterials();
        this.restoreMaterial();
    }

    slideDown() {
        this.object.castShadow = true;
        this.object.receiveShadow = true;
        this.setMaterial('org');
    }

    slideUp() {
        this.object.castShadow = false;
        this.object.receiveShadow = false;
        this.setMaterial('slided');
    }

    show() {
        this.setMaterial('slided');
    }

    hide() {
        this.setMaterial('hidden');
    }

    restoreMaterial() {
        this.setMaterial('org');
    }

    /**
     * @param {string} name název materiálu
     */
    setMaterial(name) {
        if (!this.materials.hasOwnProperty(name)) {
            return;
        }

        this.material = this.materials[name].clone();
        this.object.material = this.material;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // GET

    /**
     * @returns {THREE.Object3D}
     */
    getObject() {
        return this.object;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    beginHover() {
        let material = this.material.clone();
        material.color.r = this._blendOverlay(this.material.color.r, this.materials.hover.color.r, true);
        material.color.g = this._blendOverlay(this.material.color.g, this.materials.hover.color.g);
        material.color.b = this._blendOverlay(this.material.color.b, this.materials.hover.color.b);
        this.object.material = material;
    }

    endHover() {
        this.object.material = this.material;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        this.object.material = this.material;
    }

    deselect() {}


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @private
     */
    _initMaterials() {
        this.materials = {
            org: this.object.material.clone(),
            hover: this.object.material.clone(),
            slided: this.object.material.clone(),
            hidden: this.object.material.clone()
        };

        this.materials.hover.color = new THREE.Color(0xbb9759);

        this.materials.slided.transparent = true;
        this.materials.slided.opacity = 0.5;

        this.materials.hidden.transparent = true;
        this.materials.hidden.opacity = 0;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {number} target
     * @param {number} blend
     *
     * @return {number}
     *
     * @private
     */
    _blendOverlay(target, blend) {
        target *= 0.75;    // korekce: pokud je hodnota = 1 (např. bílá barva), pak výsledek je beze změny

        if (target > 0.5) {
            return 1 - (1 - 2 * (target - 0.5)) * (1 - blend);
        } else {
            return 2 * target * blend;
        }
    }
}
const STATUS_AVAILABLE = 0;
const STATUS_RESERVED = 1;
const STATUS_SOLD = 3;

class FlatObj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {Card}           card
     */
    constructor(name, object, card) {
        /** @type {string} */
        this.name = name;

        /** @type {THREE.Object3D} */
        this.object = object;

        /** @type {Card} */
        this.card = card;

        /** @type {{}} */
        this.data = null;

        /** @type {{}} */
        this.materials = {};


        this._initData();
        this._initMaterials();
        this.restoreMaterial();
    }

    /**
     * @param {function(THREE.Object3D)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        this.object.traverse(part => {
            if (part.type === 'Mesh') {
                callback(part);
            }
        });
    }

    /**
     * @param {function(THREE.Object3D)} callback
     */
    traversePrimary(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        this.traverse(part => {
            if (part.name.slice(-2) === '_0') {
                callback(part);
            }
        });
    }

    /**
     * @param {function(THREE.Object3D)} callback
     */
    traverseSecondary(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        this.traverse(part => {
            if (part.name.slice(-2) === '_1') {
                callback(part);
            }
        });
    }

    restoreMaterial() {
        let material = this.materials.sold;
        let materialScnd = this.materials.soldScnd;
        if (this.data.status === STATUS_AVAILABLE) {
            material = this.materials.available;
            materialScnd = this.materials.availableScnd;
        } else if (this.data.status === STATUS_RESERVED) {
            material = this.materials.reserved;
            materialScnd = this.materials.reservedScnd;
        }

        this.traversePrimary(part => {
            part.material = material;
        });
        this.traverseSecondary(part => {
            part.material = materialScnd;
        });
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    beginHover() {
        this.card.updateData(this.data);
        this.card.show();

        let material = this.materials.soldHover;
        let materialScnd = this.materials.soldScndHover;
        if (this.data.status === STATUS_AVAILABLE) {
            material = this.materials.availableHover;
            materialScnd = this.materials.availableScndHover;
        } else if (this.data.status === STATUS_RESERVED) {
            material = this.materials.reservedHover;
            materialScnd = this.materials.reservedScndHover;
        }

        this.traversePrimary(part => {
            part.material = material;
        });
        this.traverseSecondary(part => {
            part.material = materialScnd;
        });
    }

    endHover() {
        this.card.hide();
        this.restoreMaterial();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        if (this.data.status !== STATUS_AVAILABLE && this.data.status !== STATUS_RESERVED) {
            return;
        }

        window.location.href = URL_DETAIL + '/' + this.data.alias;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @private
     */
    _initData() {
        this.data = {
            name: this.name,
            alias: '',
            type: '',
            typeFormatted: '',
            building: '',
            floor: 0,
            orientation: '',
            disposition: '',
            area: 0,
            areaFormatted: '',
            price: 0,
            priceFormatted: '',
            status: STATUS_SOLD,
            statusFormatted: '',
            files: {
                pdf: ''
            }
        };

        if (DATA.flats.hasOwnProperty(this.name)) {
            let data = DATA.flats[this.name];
            this.data.name = data.name;
            this.data.alias = data.alias;
            this.data.type = data.type;
            this.data.building = data.building;
            this.data.floor = Number(data.floor);
            this.data.orientation = data.orientation;
            this.data.disposition = data.disposition;
            this.data.area = Number(data.area);
            this.data.areaFormatted = data.areaFormatted;
            this.data.price = Number(data.price);
            this.data.priceFormatted = data.priceFormatted;
            this.data.status = data.status;
            this.data.files.pdf = data.files.pdf;

            if (CS) {
                this.data.typeFormatted = data.typeFormattedCs;
                this.data.statusFormatted = data.statusFormattedCs;
            } else {
                this.data.typeFormatted = data.typeFormattedEn;
                this.data.statusFormatted = data.statusFormattedEn;
            }
        }
    }

    /**
     * @private
     */
    _initMaterials() {
        this.materials = {
            // available: new THREE.MeshPhongMaterial({color: 0xebebeb}),
            available: new THREE.MeshPhongMaterial({color: 0xd2d2d2}),
            // availableHover: new THREE.MeshPhongMaterial({color: 0xd0b77f}),
            availableHover: new THREE.MeshPhongMaterial({color: 0x9a7634}),
            // availableScnd: new THREE.MeshPhongMaterial({color: 0xe3e0d5}),
            availableScnd: new THREE.MeshPhongMaterial({color: 0xc5c0a9}),
            // availableScndHover: new THREE.MeshPhongMaterial({color: 0xd0c5ad}),
            availableScndHover: new THREE.MeshPhongMaterial({color: 0xa08d6a}),

            // reserved: new THREE.MeshPhongMaterial({color: 0xdecca5}),
            reserved: new THREE.MeshPhongMaterial({color: 0xbb9a61}),
            // reservedHover: new THREE.MeshPhongMaterial({color: 0xc4b492}),
            reservedHover: new THREE.MeshPhongMaterial({color: 0x8e774b}),
            // reservedScnd: new THREE.MeshPhongMaterial({color: 0xcdbd9a}),
            reservedScnd: new THREE.MeshPhongMaterial({color: 0x9e8555}),
            // reservedScndHover: new THREE.MeshPhongMaterial({color: 0xb6a789}),
            reservedScndHover: new THREE.MeshPhongMaterial({color: 0x7b6640}),

            // sold: new THREE.MeshPhongMaterial({color: 0xbebebe}),
            sold: new THREE.MeshPhongMaterial({color: 0x848484}),
            // soldHover: new THREE.MeshPhongMaterial({color: 0xa5a5a5}),
            soldHover: new THREE.MeshPhongMaterial({color: 0x5f5f5f}),
            // soldScnd: new THREE.MeshPhongMaterial({color: 0xb0b0b0}),
            soldScnd: new THREE.MeshPhongMaterial({color: 0x717171}),
            // soldScndHover: new THREE.MeshPhongMaterial({color: 0x999999})
            soldScndHover: new THREE.MeshPhongMaterial({color: 0x525252})
        };
    }
}
class CommerceObj extends FlatObj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {Card}           card
     */
    constructor(name, object, card) {
        super(name, object, card);
    }

    restoreMaterial() {
        let material = this.materials.sold;
        if (this.data.status === STATUS_AVAILABLE) {
            material = this.materials.available;
        } else if (this.data.status === STATUS_RESERVED) {
            material = this.materials.reserved;
        }

        this.traverse(part => {
            part.material = material;
        });
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    beginHover() {
        this.card.updateData(this.data);
        this.card.show();

        let material = this.materials.soldHover;
        if (this.data.status === STATUS_AVAILABLE) {
            material = this.materials.availableHover;
        } else if (this.data.status === STATUS_RESERVED) {
            material = this.materials.reservedHover;
        }

        this.traverse(part => {
            part.material = material;
        });
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        if (this.data.status !== STATUS_AVAILABLE && this.data.status !== STATUS_RESERVED) {
            return;
        }

        let a = document.createElement('A');
        a.href = URL_DETAIL + '/' + this.data.alias;
        //a.href = this.data.files.pdf;
        // a.target = '_blank';
        //a.download = this.data.alias + '.pdf';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}
class Obj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        /** @type {string} */
        this.name = name;

        /** @type {THREE.Object3D} */
        this.object = object;
        this.object.name = this.name;
        this.object.matrixAutoUpdate = false;
        this.object.updateMatrix();

        /** @type {boolean} */
        this.pickable = pickable;

        /** @type {Element} */
        this.element = element;
    }

    show() {
        this.object.visible = true;
    }

    hide() {
        this.object.visible = false;
    }

    /**
     * @param {number} rotationX
     * @param {number} rotationY
     */
    rotatate(rotationX, rotationY) {
        this.object.rotation.x = 0;
        this.object.rotation.y = 0;
        this.object.rotation.z = 0;
        this.object.rotateY(rotationY);
        this.object.rotateX(rotationX);
        this.object.updateMatrix();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // GET / SET

    /**
     * @param {Element} element
     */
    setElement(element) {
        this.element = element;
    }

    /**
     * @returns {string}
     */
    getName() {
        return this.name;
    }

    /**
     * @returns {boolean}
     */
    isPickable() {
        return this.pickable;
    }

    /**
     * @returns {THREE.Object3D}
     */
    getObject() {
        return this.object;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    beginHover(target, point) {}

    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    updateHover(target, point) {}

    endHover() {}


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {}

    deselect() {}
}
class ObjModel extends Obj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        super(name, object, pickable, element);

        /** @type {SubObj[]} */
        this.parts = [];


        this._initParts();
    }

    /**
     * @param {function(SubObj)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let i = 0; i < this.parts.length; ++i) {
            callback(this.parts[i]);
        }
    }

    /**
     * Obnova materiálů všech částí objektu do původního stavu
     */
    restoreMaterial() {
        this.traverse(part => {
            part.restoreMaterial();
        });
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover
    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    beginHover(target, point) {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.beginHover();
        });

        if (this.element) {
            this.element.style.display = 'block';
        }
    }

    endHover() {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.endHover();
        });

        if (this.element) {
            this.element.style.display = 'none';
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.select();
        });
    }

    deselect() {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.deselect();
        });
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @private
     */
    _initParts() {
        this.object.traverse(object => {
            if (!object.isMesh) {
                return;
            }

            object.castShadow = true;
            object.receiveShadow = true;
            object.material = this._initMaterial(object.material);

            this.parts.push(new SubObj(object));
        });
    }

    /**
     * @param {THREE.Material} org původní importovaný materiál
     *
     * @returns {THREE.Material}
     *
     * @private
     */
    _initMaterial(org) {
        let material = new THREE.MeshPhongMaterial();
        material.color = new THREE.Color(org.color.r * 2, org.color.g * 2, org.color.b * 2);
        for (let property in org) {
            if (org.hasOwnProperty(property) && material.hasOwnProperty(property) && property !== 'type' && property !== 'color') {
                material[property] = org[property];
            }
        }

        return material;
    }
}
const OBJ_STATE_NORMAL = 'normal';
const OBJ_STATE_SLIDED = 'slided';
const OBJ_STATE_HIDDEN = 'hidden';

class ObjModelFloor extends ObjModel
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        super(name, object, pickable, element);

        /** @type {string} */
        this.state = OBJ_STATE_NORMAL;

        /** @type {CardFloor} */
        this.card = null;

        /** @type {CardFloorStatic} */
        this.cardStatic = null;
    }

    /**
     * @param {CardFloor} card
     */
    setCard(card) {
        this.card = card;
    }

    /**
     * @param {CardFloorStatic} card
     */
    setCardStatic(card) {
        this.cardStatic = card;
    }

    slideDown() {
        this.traverse(part => {
            part.slideDown();
        });
        this.state = OBJ_STATE_NORMAL;
    }

    slideUp() {
        this.traverse(part => {
            part.slideUp();
        });
        this.state = OBJ_STATE_SLIDED;
    }

    show() {
        this.object.visible = true;
        this.traverse(part => {
            part.show();
        });
        this.state = OBJ_STATE_SLIDED;
    }

    hide() {
        this.object.visible = false;
        this.traverse(part => {
            part.hide();
        });
        this.state = OBJ_STATE_HIDDEN;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover
    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    beginHover(target, point) {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.beginHover();
        });

        if (this.element) {
            this.element.style.display = 'block';
        }

        if (this.card && this.state === OBJ_STATE_NORMAL) {
            this.card.updatePosition(point);
            this.card.updateData();
            this.card.show();
        }
    }

    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    updateHover(target, point) {
        if (!this.pickable) {
            return;
        }

        if (this.card) {
            this.card.updatePosition(point);
        }
    }

    endHover() {
        if (!this.pickable) {
            return;
        }

        this.traverse(part => {
            part.endHover();
        });

        if (this.element) {
            this.element.style.display = 'none';
        }

        if (this.card) {
            this.card.hide();
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // activation

    activate() {
        if (this.cardStatic) {
            this.cardStatic.show();
        }
    }

    deactivate() {
        if (this.cardStatic) {
            this.cardStatic.hide();
        }
    }
}
class ObjPlan extends Obj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        super(name, object, pickable, element);

        /** @type {{}} */
        this.opt = {};

        /** @type {Card} */
        this.card = null;

        /** @type {{}} */
        this.flats = {};

        /** @type {{}} */
        this.commerces = {};

        /** @type {FlatObj} */
        this.hoveredFlat = null;
    }

    /**
     * @param {{}} opt
     */
    setOpt(opt) {
        this.opt = opt;

        this.object.traverse(object => {
            if (object.type === 'Group' && this.opt.flats.hasOwnProperty(object.name)) {
                this.flats[object.name] = new FlatObj(object.name, object, this.card);
            }
            if (object.type === 'Mesh' && this.opt.commerces.hasOwnProperty(object.name)) {
                this.commerces[object.name] = new CommerceObj(object.name, object, this.card);
            }
        });
    }

    /**
     * @param {Card} card
     */
    setCard(card) {
        this.card = card;
    }

    /**
     * @param {function(FlatObj)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let name in this.flats) {
            if (this.flats.hasOwnProperty(name)) {
                callback(this.flats[name]);
            }
        }
        for (let name in this.commerces) {
            if (this.commerces.hasOwnProperty(name)) {
                callback(this.commerces[name]);
            }
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover
    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    beginHover(target, point) {
        if (!this.pickable) {
            return;
        }

        let flat = this._getPickedFlat(target);
        if (!flat) {
            return;
        }

        this.endHover();
        this.hoveredFlat = flat;
        this.hoveredFlat.beginHover();

        if (this.card) {
            this.card.updatePosition(point);
        }
    }

    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    updateHover(target, point) {
        if (!this.pickable) {
            return;
        }

        let flat = this._getPickedFlat(target);
        if (!flat) {
            this.endHover();
            return;
        }

        if (this.card) {
            this.card.updatePosition(point);
        }

        if (this.hoveredFlat && this.hoveredFlat.name === flat.name) {
            return;
        }

        this.endHover();
        this.hoveredFlat = flat;
        this.hoveredFlat.beginHover();
    }

    endHover() {
        if (!this.pickable || !this.hoveredFlat) {
            return;
        }

        this.hoveredFlat.endHover();
        this.hoveredFlat = null;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        if (!this.pickable || !this.hoveredFlat) {
            return;
        }

        this.hoveredFlat.select();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {THREE.Object3D} target
     *
     * @return {FlatObj} NULL, pokud nebyl vybrán žádný byt
     *
     * @private
     */
    _getPickedFlat(target) {
        let object;

        object = target;
        while ((object.type !== 'Group' || !this.flats.hasOwnProperty(object.name)) && object.parent) {
            object = object.parent;
        }
        if (object && object.type === 'Group' && this.flats.hasOwnProperty(object.name)) {
            return this.flats[object.name];
        }

        object = target;
        while ((object.type !== 'Mesh' || !this.commerces.hasOwnProperty(object.name)) && object.parent) {
            object = object.parent;
        }
        if (object && object.type === 'Mesh' && this.commerces.hasOwnProperty(object.name)) {
            return this.commerces[object.name];
        }

        return null;
    }
}
class ObjPointInterest extends Obj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        super(name, object, pickable, element);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    /**
     * @param {THREE.Object3D} target
     * @param {THREE.Vector3}  point
     */
    beginHover(target, point) {
        if (!this.pickable) {
            return;
        }

        this.object.material.depthTest = false;

        if (this.element) {
            this.element.style.display = 'block';
        }
    }

    endHover() {
        if (!this.pickable) {
            return;
        }

        this.object.material.depthTest = true;

        if (this.element) {
            this.element.style.display = 'none';
        }
    }
}
class ObjPointView extends Obj
{
    /**
     * Constructor
     *
     * @param {string}         name
     * @param {THREE.Object3D} object
     * @param {boolean}        pickable
     * @param {Element}        element
     */
    constructor(name, object, pickable = false, element = null) {
        super(name, object, pickable, element);

        /** @type {Element} */
        this.btnClose = null;

        /** @type {string} */
        this.img = '';


        if (this.element) {
            this.element.addEventListener('click', this._callbackBtnClose.bind(this));
        }
    }

    /**
     * @param {string} img
     */
    setImg(img) {
        this.img = img;
    }

    /**
     * @param {Element} element
     */
    setElement(element) {
        this.element = element;
        this.element.addEventListener('click', this._callbackBtnClose.bind(this));
    }

    /**
     * @param {Element} element
     */
    setBtnClose(element) {
        this.btnClose = element;
        this.btnClose.addEventListener('click', this._callbackBtnClose.bind(this));
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    select() {
        this.element.style.backgroundImage = `url('${this.img}')`;
        this.element.style.display = 'block';
    }

    deselect() {
        this.element.style.display = 'none';
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _callbackBtnClose(event) {
        event.stopPropagation();
        this.deselect();
    }
}
class Objs
{
    /**
     * Constructor
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        /** @type {HTMLElement} */
        this.container = container;

        /** @type {{}} */
        this.objs = {};

        /** @type {THREE.Object3D} */
        this.object = new THREE.Group();

        /** @type {THREE.Object3D[]} */
        this.pickableObjects = [];

        /** @type {Obj} */
        this.hoveredObj = null;

        /** @type {Obj} */
        this.selectedObj = null;
    }

    /**
     * @param {Obj} obj
     */
    add(obj) {
        this.objs[obj.getName()] = obj;
        this.object.add(obj.getObject());
        if (obj.isPickable()) {
            this.pickableObjects.push(obj.getObject());
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // GET

    /**
     * 3D objekt reprezentující skupinu všech importovaných objektů
     *
     * @returns {THREE.Object3D}
     */
    getObject() {
        return this.object;
    }

    /**
     * @returns {THREE.Object3D[]}
     */
    getPickableObjects() {
        return this.pickableObjects;
    }

    /**
     * @param {string} name
     *
     * @return {Obj}
     */
    getObj(name) {
        if (this.objs.hasOwnProperty(name)) {
            return this.objs[name];
        }
        return null;
    }

    /**
     * @param {function(Obj)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let name in this.objs) {
            if (this.objs.hasOwnProperty(name)) {
                callback(this.objs[name]);
            }
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // hover

    /**
     * Je na nějakém objektu hover?
     *
     * @returns {boolean}
     */
    isHover() {
        return (this.hoveredObj !== null);
    }

    /**
     * Vrací objekt, na kterém je hover
     *
     * @returns {Obj}
     */
    getHovered() {
        return this.hoveredObj;
    }

    /**
     * Začátek hoveru na objektu
     *
     * @param {{distance: number, point: THREE.Vector3, face: THREE.Face3, faceIndex: number, object: THREE.Object3D}[]} targets
     */
    beginHover(targets) {
        if (!targets.length) {
            this.endHover();
            return;
        }

        let object = targets[0].object;
        if (!this.objs.hasOwnProperty(object.name)) {
            while (object && object.type !== 'Scene') {
                object = object.parent;
            }
            if (!object || object.type !== 'Scene' || !this.objs.hasOwnProperty(object.name)) {
                this.endHover();
                return;
            }
        }

        let obj = this.objs[object.name];

        // tento objekt už je vybrán
        if (this.hoveredObj && this.hoveredObj.getName() === obj.getName()) {
            this.hoveredObj.updateHover(targets[0].object, targets[0].point);
            return;
        }

        // pokud je vybrán jiný objekt, původní se "odvybere"
        this.endHover();

        this.hoveredObj = obj;
        this.hoveredObj.beginHover(targets[0].object, targets[0].point);
        this.container.style.cursor = 'pointer';
    }

    /**
     * Konec hoveru
     */
    endHover() {
        if (this.hoveredObj) {
            this.hoveredObj.endHover();
            this.hoveredObj = null;
            this.container.style.cursor = 'default';
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // select

    /**
     * Je vybrán nějaký objekt?
     *
     * @returns {boolean}
     */
    isSelected() {
        return (this.selectedObj !== null);
    }

    /**
     * Vrací vybraný objekt
     *
     * @returns {Obj}
     */
    getSelected() {
        return this.selectedObj;
    }

    /**
     * Výběr objektu
     *
     * @param {Obj} obj
     */
    select(obj) {
        if (obj.isPickable()) {
            this.deselect();
            this.selectedObj = obj;
            this.selectedObj.select();
        }
    }

    /**
     * Zrušení výběru
     */
    deselect() {
        if (this.selectedObj) {
            this.selectedObj.deselect();
            this.selectedObj = null;
        }
    }
}
class Animation
{
    /**
     * Constructor
     *
     * @param {Obj}    obj
     * @param {number} duration
     * @param {{}}     options
     */
    constructor(obj, duration, options = {}) {
        /** @type {Obj} */
        this.obj = obj;

        /** @type {number} */
        this.duration = duration;

        /** @type {THREE.AnimationMixer} */
        if (this.obj) {
            this.mixer = new THREE.AnimationMixer(this.obj.getObject());
            this.mixer.addEventListener('finished', this._callbackEnded.bind(this));
        }

        /** @type {THREE.AnimationAction} */
        this.action = null;

        /** @type {Function} */
        this.callbackEnded = null;


        this._init(options);
    }

    /**
     * @param {number} deltaTime
     */
    update(deltaTime) {
        this.mixer.update(deltaTime);
    }

    /**
     * @returns {Animation}
     */
    play() {
        if (this.action) {
            this._callbackBegan();
            this.action.paused = false;
            this.action.play();
        }
        return this;
    }

    pause() {
        if (this.action) {
            this.action.paused = true;
        }
    }

    /**
     * @returns {Animation}
     */
    reset() {
        if (this.action) {
            this.action.reset();
        }
        return this;
    }

    /**
     * @returns {Animation}
     */
    stop() {
        if (this.action) {
            this.action.stop();
        }
        return this;
    }

    /**
     * @returns {THREE.AnimationAction}
     */
    getAction() {
        return this.action;
    }

    /**
     * @param {Function} callback
     */
    setCallbackEnded(callback) {
        if (typeof callback === 'function') {
            this.callbackEnded = callback;
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {}


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @protected
     */
    _callbackBegan() {}

    /**
     * @protected
     */
    _callbackEnded() {
        if (typeof this.callbackEnded === 'function') {
            this.callbackEnded();
        }
    }
}
class AnimationFloorSlideUp extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        this.height = options.height;

        let tracks = [];
        tracks.push(new THREE.VectorKeyframeTrack(
            '.position',
            [0, this.duration],
            [
                0, 0, 0,
                0, this.height, 0,
            ],
            THREE.InterpolateSmooth
        ));
        this.obj.traverse((part) => {
            let object = part.getObject();

            object.material.transparent = true;
            tracks.push(new THREE.NumberKeyframeTrack(
                object.name + '.material.opacity',
                [0, this.duration],
                [object.material.opacity, 0.5]
            ));
        });

        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
        // this.action.fadeIn(this.duration * 0.5);
    }

    /**
     * @protected
     */
    _callbackBegan() {
        this.obj.object.matrixAutoUpdate = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.slideUp();

        this.obj.object.matrixAutoUpdate = false;
        this.obj.object.position.set(0, this.height, 0);
        this.obj.object.updateMatrix();

        super._callbackEnded();
    }
}
class AnimationFloorSlideDown extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let position = this.obj.getObject().position;

        let opacity = 0.5;
        if (this.obj.state === OBJ_STATE_HIDDEN) {
            opacity = 0;
        }

        let tracks = [];
        tracks.push(new THREE.VectorKeyframeTrack(
            '.position',
            [0, this.duration],
            [
                position.x, position.y, position.z,
                0, 0, 0,
            ],
            THREE.InterpolateSmooth
        ));
        this.obj.traverse((part) => {
            let object = part.getObject();

            object.material.transparent = true;
            tracks.push(new THREE.NumberKeyframeTrack(
                object.name + '.material.opacity',
                [0, this.duration],
                [opacity, part.materials.org.opacity]
            ));
        });

        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
        // this.action.fadeIn(this.duration * 0.5);
    }

    /**
     * @protected
     */
    _callbackBegan() {
        this.obj.show();
        this.obj.object.matrixAutoUpdate = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.slideDown();

        this.obj.object.matrixAutoUpdate = false;
        this.obj.object.position.set(0, 0, 0);
        this.obj.object.updateMatrix();

        super._callbackEnded();
    }
}
class AnimationFloorHide extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let tracks = [];
        this.obj.traverse((part) => {
            let object = part.getObject();

            object.material.transparent = true;
            tracks.push(
                new THREE.NumberKeyframeTrack(
                    object.name + '.material.opacity',
                    [0, this.duration],
                    [object.material.opacity, 0]
                )
            );
        });
        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.hide();

        super._callbackEnded();
    }
}
class AnimationFloorShow extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let tracks = [];
        this.obj.traverse((part) => {
            let object = part.getObject();

            object.material.transparent = true;
            tracks.push(
                new THREE.NumberKeyframeTrack(
                    object.name + '.material.opacity',
                    [0, this.duration],
                    [0, 0.5]
                )
            );
        });
        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
    }

    /**
     * @protected
     */
    _callbackBegan() {
        this.obj.object.visible = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.show();

        super._callbackEnded();
    }
}
class AnimationPlanSlideUp extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let track = new THREE.VectorKeyframeTrack(
            '.position',
            [0, this.duration],
            [
                0, 0, 0,
                0, options.height, 0,
            ],
            THREE.InterpolateSmooth
        );

        let clip = new THREE.AnimationClip(null, this.duration, [track]);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
        // this.action.fadeIn(this.duration * 0.5);
    }

    /**
     * @protected
     */
    _callbackBegan() {
        this.obj.object.matrixAutoUpdate = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.object.matrixAutoUpdate = false;
        this.obj.object.updateMatrix();

        super._callbackEnded();
    }
}
class AnimationPlanSlideDown extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let track = new THREE.VectorKeyframeTrack(
            '.position',
            [0, this.duration],
            [
                0, options.height, 0,
                0, 0, 0,
            ],
            THREE.InterpolateSmooth
        );

        let clip = new THREE.AnimationClip(null, this.duration, [track]);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
        // this.action.fadeIn(this.duration * 0.5);
    }

    /**
     * @protected
     */
    _callbackBegan() {
        this.obj.object.matrixAutoUpdate = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.object.matrixAutoUpdate = false;
        this.obj.object.position.set(0, 0, 0);
        this.obj.object.updateMatrix();

        super._callbackEnded();
    }
}
class AnimationPlanHide extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        let tracks = [];
        this.obj.getObject().traverse(object => {
            if (!object.isMesh) {
                return;
            }

            object.material.transparent = true;
            tracks.push(
                new THREE.NumberKeyframeTrack(
                    object.name + '.material.opacity',
                    [0, this.duration],
                    [1, 0]
                )
            );
        });
        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.hide();
        this.obj.getObject().traverse(object => {
            if (object.isMesh) {
                object.material.transparent = false;
                object.material.opacity = 0;
            }
        });

        super._callbackEnded();
    }
}
class AnimationPlanShow extends Animation
{
    /**
     * @param {{}} options
     *
     * @protected
     */
    _init(options = {}) {
        this.obj.show();

        let tracks = [];
        this.obj.getObject().traverse(object => {
            if (!object.isMesh) {
                return;
            }

            object.material.transparent = true;
            tracks.push(
                new THREE.NumberKeyframeTrack(
                    object.name + '.material.opacity',
                    [0, this.duration],
                    [0, 1]
                )
            );
        });
        let clip = new THREE.AnimationClip(null, this.duration, tracks);

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
    }

    /**
     * @protected
     */
    _callbackEnded() {
        this.obj.getObject().traverse(object => {
            if (object.isMesh) {
                object.material.transparent = false;
                object.material.opacity = 1;
            }
        });

        super._callbackEnded();
    }
}
class AnimationCamera extends Animation
{
    /**
     * Constructor
     *
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.AnimationClip}     clip
     */
    constructor(camera, clip) {
        super(null, clip.duration);

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {THREE.AnimationMixer} */
        this.mixer = new THREE.AnimationMixer(this.camera);
        this.mixer.addEventListener('finished', this._callbackEnded.bind(this));

        this.action = this.mixer.clipAction(clip);
        this.action.setLoop(THREE.LoopOnce);
        this.action.clampWhenFinished = true;
    }
}
class Animations
{
    /**
     * Constructor
     */
    constructor() {
        /** @type {{}} */
        this.animations = {};

        /** @type {THREE.Clock} */
        this.clock = new THREE.Clock();
    }

    update() {
        let deltaTime = this.clock.getDelta();
        for (let name in this.animations) {
            if (this.animations.hasOwnProperty(name)) {
                this.animations[name].update(deltaTime);
            }
        }
    }

    /**
     * @param {string}    name
     * @param {Animation} animation
     */
    setAnimation(name, animation) {
        this.animations[name] = animation;
    }

    /**
     * @param {string} name
     *
     * @returns {Animation}
     */
    getAnimation(name) {
        if (this.animations.hasOwnProperty(name)) {
            return this.animations[name];
        }
        return null;
    }
}
class Floor
{
    /**
     * Constructor
     *
     * @param {number}        no
     * @param {ObjModelFloor} obj
     * @param {ObjPlan}       objPlan
     * @param {{}}            opt
     */
    constructor(no, obj, objPlan, opt) {
        /** @type {number} */
        this.no = no;

        /** @type {ObjModelFloor} */
        this.obj = obj;

        /** @type {ObjPlan} */
        this.objPlan = objPlan;

        /** @type {number} */
        this.targetY = opt.targetY;
    }
}
class Building
{
    /**
     * Constructor
     *
     * @param {Animations}              animations
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.OrbitControls}     controls
     * @param {{}}                      floorBtns
     */
    constructor(animations, camera, controls, floorBtns) {
        /** @type {Animations} */
        this.animations = animations;

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {THREE.OrbitControls} */
        this.controls = controls;
        this.controls.addEventListener('change', this._callbackControlsChanged.bind(this));

        /** @type {{}} */
        this.floorBtns = floorBtns;

        /** @type {{}} */
        this.floors = {};

        /** @type {Floor} */
        this.activeFloor = null;

        /** @type {number} */
        this.minFloorNo = 999;

        /** @type {number} */
        this.maxFloorNo = -999;

        /** @type {THREE.Box3} */
        this.bbLower = new THREE.Box3();

        /** @type {THREE.Box3} */
        this.bbUpper = new THREE.Box3();

        /** @type {number} */
        this.floorChangeCounter = 0;

        /** @type {THREE.Vector3} */
        this.defaultCameraPosition = this.camera.position.clone();

        /** @type {THREE.Vector3} */
        this.defaultControlTarget = this.controls.target.clone();
    }

    /**
     * @param {Floor} floor
     */
    addFloor(floor) {
        this.floors[floor.no] = floor;
        if (floor.no < this.minFloorNo) {
            this.minFloorNo = floor.no;
        }
        if (floor.no > this.maxFloorNo) {
            this.maxFloorNo = floor.no;
        }
    }

    /**
     * @param {number|null}     from
     * @param {number|null}     to
     * @param {function(Floor)} callback
     */
    traverseFloors(from, to, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let floorNo in this.floors) {
            if ((!from || floorNo >= from) && (!to || floorNo <= to) && this.floors.hasOwnProperty(floorNo)) {
                callback(this.floors[floorNo]);
            }
        }
    }

    activateNextFloor() {
        if (!this.activeFloor) {
            this.activateFloor(this.minFloorNo);
            return;
        }

        let floorNo = this.activeFloor.no + 1;
        if (floorNo <= this.maxFloorNo) {
            this.activateFloor(floorNo);
        } else {
            // this.deactivateFloor();
        }
    }

    activatePrevFloor() {
        if (!this.activeFloor) {
            this.activateFloor(this.maxFloorNo);
            return;
        }

        let floorNo = this.activeFloor.no - 1;
        if (floorNo >= this.minFloorNo) {
            this.activateFloor(floorNo);
        } else {
            // this.deactivateFloor();
        }
    }

    /**
     * @param {number} floorNo
     * @param {string} objState
     */
    activateFloor(floorNo, objState = OBJ_STATE_NORMAL) {
        if (!this.floors.hasOwnProperty(floorNo) || this.floorChangeCounter !== 0) {
            return;
        }

        if (objState === OBJ_STATE_SLIDED) {
            floorNo++;
        }
        if (floorNo > this.maxFloorNo) {
            this.deactivateFloor();
            return;
        }

        if (!this.activeFloor) {
            this.traverseFloors(floorNo, null, (floor) => {
                this._slideUpFloor(floor);
            });
            this._showPlan(this.floors[floorNo], false);
        } else if (this.activeFloor.no === floorNo) {
            return;
        } else if (floorNo < this.activeFloor.no) {
            this._hidePlan(this.activeFloor, true);
            this.traverseFloors(floorNo, this.activeFloor.no - 1, (floor) => {
                this._slideUpFloor(floor);
            });
            this._showPlan(this.floors[floorNo], false);
        } else {
            this._hidePlan(this.activeFloor, false);
            this.traverseFloors(this.activeFloor.no, floorNo - 1, (floor) => {
                this._slideDownFloor(floor);
            });
            this._showPlan(this.floors[floorNo], true);
        }

        if (this.activeFloor && this.activeFloor.no !== floorNo) {
            this.activeFloor.obj.deactivate();
        }

        this.activeFloor = this.floors[floorNo];
        this.activeFloor.obj.activate();
        this._zoomFloor(this.activeFloor);

        for (let floor in this.floorBtns) {
            this.floorBtns[floor].classList.remove('active');
        }
        this.floorBtns[floorNo].classList.add('active');
    }

    deactivateFloor() {
        if (!this.activeFloor || this.floorChangeCounter !== 0) {
            return;
        }

        this.activeFloor.obj.deactivate();

        this.traverseFloors(this.activeFloor.no, null, (floor) => {
            this._slideDownFloor(floor);
        });
        this.traverseFloors(this.activeFloor.no + 1, null, (floor) => {
            this._resetPlan(floor);
        });
        this._hidePlan(this.activeFloor, false);
        this.activeFloor = null;
        this._zoomBuilding();

        for (let floor in this.floorBtns) {
            this.floorBtns[floor].classList.remove('active');
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {Floor} floor
     *
     * @private
     */
    _slideUpFloor(floor) {
        this.floorChangeCounter++;

        let animation = new AnimationFloorSlideUp(floor.obj, 0.5, {height: 30});
        animation.setCallbackEnded(this._callbackFloorChanged.bind(this));
        animation.play();
        this.animations.setAnimation('floorSlideUp:' + floor.obj.getName(), animation);
    }

    /**
     * @param {Floor} floor
     *
     * @private
     */
    _slideDownFloor(floor) {
        this.floorChangeCounter++;

        let animation = new AnimationFloorSlideDown(floor.obj, 0.5);
        animation.setCallbackEnded(this._callbackFloorChanged.bind(this));
        animation.play();
        this.animations.setAnimation('floorSlideDown:' + floor.obj.getName(), animation);
    }

    /**
     * @private
     */
    _hideSlidedFloors() {
        this.traverseFloors(null, null, floor => {
            if (floor.obj.state !== OBJ_STATE_SLIDED) {
                return;
            }

            this.floorChangeCounter++;

            let animation = new AnimationFloorHide(floor.obj, 0.2);
            animation.setCallbackEnded(() => {
                this.floorChangeCounter--;
            });
            animation.play();
            this.animations.setAnimation('floorHide:' + floor.obj.getName(), animation);
        });
    }

    /**
     * @private
     */
    _showSlidedFloors() {
        this.traverseFloors(null, null, floor => {
            if (floor.obj.state !== OBJ_STATE_HIDDEN) {
                return;
            }

            this.floorChangeCounter++;

            let animation = new AnimationFloorShow(floor.obj, 0.2);
            animation.setCallbackEnded(() => {
                this.floorChangeCounter--;
            });
            animation.play();
            this.animations.setAnimation('floorShow:' + floor.obj.getName(), animation);
        });
    }

    /**
     * @param {Floor}   floor
     * @param {Boolean} slideUp
     *
     * @private
     */
    _hidePlan(floor, slideUp = false) {
        if (!floor.objPlan) {
            return;
        }

        let animation;

        animation = new AnimationPlanHide(floor.objPlan, 0.5);
        animation.play();
        this.animations.setAnimation('planHide:' + floor.objPlan.getName(), animation);

        if (slideUp) {
            animation = new AnimationPlanSlideUp(floor.objPlan, 0.5, {height: 30});
            animation.play();
            this.animations.setAnimation('planSlideUp:' + floor.obj.getName(), animation);
        }
    }

    /**
     * @param {Floor}   floor
     * @param {Boolean} slideDown
     *
     * @private
     */
    _showPlan(floor, slideDown = false) {
        if (!floor.objPlan) {
            return;
        }

        let animation;

        animation = new AnimationPlanShow(floor.objPlan, 0.5);
        animation.play();
        this.animations.setAnimation('planShow:' + floor.objPlan.getName(), animation);

        if (slideDown) {
            animation = new AnimationPlanSlideDown(floor.objPlan, 0.5, {height: 30});
            animation.play();
            this.animations.setAnimation('planSlideDown:' + floor.obj.getName(), animation);
        }
    }

    /**
     * @param {Floor} floor
     *
     * @private
     */
    _resetPlan(floor) {
        if (!floor.objPlan) {
            return;
        }

        floor.objPlan.object.position.set(0, 0, 0);
        floor.objPlan.object.updateMatrix();
    }

    /**
     * @param {Floor} floor
     *
     * @private
     */
    _zoomFloor(floor) {
        let tween;
        let deltaY = floor.targetY - this.controls.target.y;

        tween = new TWEEN.Tween(this.controls.target)
            .to({x: this.controls.target.x, y: floor.targetY, z: this.controls.target.z}, 500)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();

        tween = new TWEEN.Tween(this.camera.position)
            .to({x: this.camera.position.x, y: this.camera.position.y + deltaY, z: this.camera.position.z}, 500)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();
    }

    /**
     * @private
     */
    _zoomBuilding() {
        let tween;

        tween = new TWEEN.Tween(this.controls.target)
            .to({x: this.controls.target.x, y: this.defaultControlTarget.y, z: this.controls.target.z}, 500)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();

        tween = new TWEEN.Tween(this.camera.position)
            .to({x: this.camera.position.x, y: this.defaultCameraPosition.y, z: this.camera.position.z}, 500)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @private
     */
    _callbackFloorChanged() {
        this.floorChangeCounter--;
        if (this.floorChangeCounter !== 0) {
            return;
        }

        // bounding box části viditelné budovy a části odjeté budovy
        this.bbLower.makeEmpty();
        this.bbUpper.makeEmpty();
        this.traverseFloors(null, null, floor => {
            if (floor.obj.state === OBJ_STATE_NORMAL) {
                this.bbLower = this.bbLower.expandByObject(floor.obj.getObject());
            } else {
                this.bbUpper = this.bbUpper.expandByObject(floor.obj.getObject());
            }
        });
    }

    /**
     * Callback události: controls changed
     *
     * @param {{}} event
     *
     * @protected
     */
    _callbackControlsChanged(event) {
        if (!this.activeFloor) {
            return;
        }

        if (this.floorChangeCounter !== 0) {
            // console.log('clear: patra se mění');
            return;
        }

        let cameraPos = this.camera.position;
        let bMin = this.bbUpper.min;
        if (cameraPos.y < bMin.y) {
            // console.log('clear: kamera je pod bbUpper');
            this._showSlidedFloors();
            return;
        }

        // let bMax = this.bbUpper.max;
        // if (cameraPos.x >= bMin.x && cameraPos.x <= bMax.x && cameraPos.z >= bMin.z && cameraPos.z <= bMax.z) {
        //     console.log('unclear: kamera je uvnitř nebo nad bbUpper');
        //     this._hideSlidedFloors();
        //     return;
        // }

        let triangle = new THREE.Triangle(
            cameraPos.clone(),
            new THREE.Vector3(this.bbLower.min.x, this.bbLower.max.y, this.bbLower.min.z),
            new THREE.Vector3(this.bbLower.max.x, this.bbLower.max.y, this.bbLower.max.z)
        );
        if (this.bbUpper.intersectsTriangle(triangle)) {
            // console.log('unclear: trojúhelník protíná bbUpper');
            this._hideSlidedFloors();
            return;
        }

        // console.log('unclear');
        // this._hideSlidedFloors();

        // console.log('clear');
        this._showSlidedFloors();



        // let sphCoords = new THREE.Spherical().setFromVector3(this.camera.getWorldDirection());
        // let dist = this.camera.position.distanceTo(this.bbLower.getCenter());
        // console.log(THREE.Math.radToDeg(sphCoords.phi), sphCoords.phi, dist);
        // if (THREE.Math.radToDeg(sphCoords.phi) < 150) {
        //     console.log('clear: kamera má nízký úhel');
        //     this._showSlidedFloors();
        //     return;
        // }

        // let centerNormal = this.bbLower.getCenter();
        // let dist = this.camera.position.distanceTo(centerNormal);
        // if (dist > 120) {
        //     return;
        // }

        // let centerSlided = this.bbUpper.getCenter();
        // let vectorNormal = centerNormal.clone().sub(this.camera.position).normalize();
        // let vectorSlided = centerSlided.clone().sub(this.camera.position).normalize();
        // // console.log(vectorNormal.dot(vectorSlided));
    }
}
class Point
{
    /**
     * Constructor
     *
     * @param {Element}                 element
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {Objs}                    objs
     */
    constructor(element, container, camera, objs) {
        /** @type {Element} */
        this.element = element;

        /** @type {HTMLElement} */
        this.container = container;

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {Objs} */
        this.objs = objs;

        /** @type {string} */
        this.type = this.element.dataset.type;

        /** @type {THREE.Vector3} */
        this.position = null;
        if (this.element.dataset.position) {
            let coords = this.element.dataset.position.split(',');
            this.position = new THREE.Vector3(parseFloat(coords[0]), parseFloat(coords[1]), parseFloat(coords[2]));
        }

        /** @type {string[]} */
        this.groups = [];
        if (this.element.dataset.groups) {
            this.groups = this.element.dataset.groups.split(',');
        }

        /** @type {boolean} */
        this.visible = false;

        /** @type {boolean} */
        this.behindCamera = false;
    }

    /**
     * Vytvoření konkrétní instance bodu zájmu
     *
     * @param {Element}                 element
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {Objs}                    objs
     *
     * @returns {Point}
     */
    static create(element, container, camera, objs) {
        let type = element.dataset.type;
        switch (type) {
            case 'label':
                return new PointLabel(element, container, camera, objs);
            case 'interest':
                return new PointInterest(element, container, camera, objs);
            case 'view':
                return new PointView(element, container, camera, objs);
            default:
                console.log(`neznámý typ bodu zájmu '${type}'`);
        }
    }

    /**
     * @returns {string[]}
     */
    getGroups() {
        return this.groups;
    }

    /**
     * Aktualizace polohy
     *
     * @param {number} rotationX
     * @param {number} rotationY
     */
    update(rotationX, rotationY) {
        if (!this.position) {
            return;
        }

        let coords = this.position.clone().project(this.camera);

        let x = Math.round((0.5 + coords.x * 0.5) * (this.container.clientWidth) + this.container.offsetLeft);
        this.element.style.left = `${x}px`;

        let y = Math.round((0.5 - coords.y * 0.5) * (this.container.clientHeight) + this.container.offsetTop);
        this.element.style.top = `${y}px`;

        this.behindCamera = (coords.z > 1);
        if (!this.behindCamera) {
            let zIndex = 10000 - Math.round(coords.z * 10000) + 10000;    // z-index: 10000 až 20000
            this.element.style.zIndex = `${zIndex}`;
        }
        this._updateVisibility();
    }

    show() {
        this.visible = true;
        this._updateVisibility();
    }

    hide() {
        this.visible = false;
        this._updateVisibility();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @protected
     */
    _updateVisibility() {
        if (this.visible && !this.behindCamera) {
            this.element.style.display = 'block';
        } else {
            this.element.style.display = 'none';
        }
    }
}
class PointLabel extends Point
{
    /**
     * Constructor
     *
     * @param {Element}                 element
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {Objs}                    objs
     */
    constructor(element, container, camera, objs) {
        super(element, container, camera, objs);
    }
}
const CLASS_INFO_BOX = 'js-info-box';

class PointInterest extends Point
{
    /**
     * Constructor
     *
     * @param {Element}                 element
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {Objs}                    objs
     */
    constructor(element, container, camera, objs) {
        super(element, container, camera, objs);

        /** @type {string} */
        this.icon = this.element.dataset.icon;

        /** @type {number} */
        this.size = 10;
        if (this.element.dataset.size) {
            this.size = Number.parseInt(this.element.dataset.size);
        }

        /** @type {ObjPointInterest} */
        this.obj = null;

        /** @type {Obj} */
        this.objHelper = null;


        this._initObj();
    }

    /**
     * @param {{}} textures
     */
    setTexture(textures) {
        if (textures.hasOwnProperty(this.icon)) {
            this.obj.object.material.map = textures[this.icon];
        }
    }

    /**
     * Aktualizace polohy
     *
     * @param {number} rotationX
     * @param {number} rotationY
     */
    update(rotationX, rotationY) {
        super.update(rotationX, rotationY);

        if (this.visible) {
            this.obj.rotatate(rotationX, rotationY);
            this.objHelper.rotatate(0, rotationY);
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @returns {ObjPointInterest}
     *
     * @pprotected
     */
    _initObj() {
        let object = new THREE.Mesh(
            new THREE.PlaneGeometry(this.size, this.size, 1, 1),
            new THREE.MeshBasicMaterial({
                color: 0x153439,
                transparent: true,
                opacity: 1
            })
        );
        object.position.copy(this.position);

        let element = this.element.querySelector('.' + CLASS_INFO_BOX);
        let pickable = false;
        if (element) {
            pickable = true;
        }

        this.obj = new ObjPointInterest('pointOfInterest_' + this.element.dataset.name, object, pickable);
        this.objs.add(this.obj);

        this.obj.hide();
        this.obj.setElement(element);


        let objectHelper = new THREE.Mesh(
            new THREE.PlaneGeometry(0.5, this.position.y, 1, 1),
            new THREE.MeshBasicMaterial({color: 0x010c0e})
        );
        objectHelper.position.x = this.position.x;
        objectHelper.position.y = this.position.y * 0.5 - this.size * 0.5;
        objectHelper.position.z = this.position.z;

        this.objHelper = new Obj('pointOfInterest_helper_' + this.element.dataset.name, objectHelper);
        this.objs.add(this.objHelper);

        this.objHelper.hide();
    }

    /**
     * @protected
     */
    _updateVisibility() {
        super._updateVisibility();

        if (this.visible && !this.behindCamera) {
            this.obj.show();
            this.objHelper.show();
        } else {
            this.obj.hide();
            this.objHelper.hide();
        }
    }
}
const ID_MODEL_VIEW_BOX = 'model-view-box';
const CLASS_BTN_CLOSE = 'js-btn-close';

class PointView extends Point
{
    /**
     * Constructor
     *
     * @param {Element}                 element
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {Objs}                    objs
     */
    constructor(element, container, camera, objs) {
        super(element, container, camera, objs);

        /** @type {string} */
        this.icon = this.element.dataset.icon;

        /** @type {ObjPointView} */
        this.obj = null;

        /** @type {Obj} */
        this.objHelper = null;


        this._initObj();
    }

    /**
     * @param {{}} textures
     */
    setTexture(textures) {
        if (textures.hasOwnProperty(this.icon)) {
            this.obj.object.material.map = textures[this.icon];
        }
    }

    /**
     * Aktualizace polohy
     *
     * @param {number} rotationX
     * @param {number} rotationY
     */
    update(rotationX, rotationY) {
        super.update(rotationX, rotationY);

        if (this.visible) {
            this.obj.rotatate(rotationX, rotationY);
            this.objHelper.rotatate(0, rotationY);
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @returns {ObjPointView}
     *
     * @pprotected
     */
    _initObj() {
        let object = new THREE.Mesh(
            new THREE.PlaneGeometry(10, 10, 1, 1),
            new THREE.MeshBasicMaterial({
                color: 0x153439,
                transparent: true,
                opacity: 1
            })
        );
        object.position.copy(this.position);

        this.obj = new ObjPointView('view_' + this.element.dataset.name, object, true);
        this.objs.add(this.obj);

        this.obj.hide();


        let objectHelper = new THREE.Mesh(
            new THREE.PlaneGeometry(0.5, this.position.y, 1, 1),
            new THREE.MeshBasicMaterial({color: 0x010c0e})
        );
        objectHelper.position.x = this.position.x;
        objectHelper.position.y = this.position.y * 0.5 - 5;
        objectHelper.position.z = this.position.z;

        this.objHelper = new Obj('pointOfInterest_helper_' + this.element.dataset.name, objectHelper);
        this.objs.add(this.objHelper);

        this.objHelper.hide();


        let viewBox = document.getElementById(ID_MODEL_VIEW_BOX);
        this.obj.setElement(viewBox);
        this.obj.setBtnClose(viewBox.querySelector('.' + CLASS_BTN_CLOSE));
        this.obj.setImg(this.element.dataset.img);
    }

    /**
     * @protected
     */
    _updateVisibility() {
        super._updateVisibility();

        if (this.visible && !this.behindCamera) {
            this.obj.show();
            this.objHelper.show();
        } else {
            this.obj.hide();
            this.objHelper.hide();
        }
    }
}
/* global gv, THREE, TWEEN */

const CLASS_MODEL_POINT = 'js-model-point';

class Points
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.OrbitControls}     controls
     * @param {Objs}                    objs
     */
    constructor(container, camera, controls, objs) {
        /** @type {HTMLElement} */
        this.container = container;

        /** @type {THREE.PerspectiveCamera} */
        this.camera = camera;

        /** @type {THREE.OrbitControls} */
        this.controls = controls;
        this.controls.addEventListener('change', this._callbackControlsChanged.bind(this));

        /** @type {Objs} */
        this.objs = objs;

        /** @type {Point[]} */
        this.points = [];

        /** @type {{}} */
        this.groups = {
            general: [],
        };

        /** @type {string} */
        this.activeGroup = '';

        /** @type {{}} */
        this.textures = {};

        /** @type {{x: number, y: number}} */
        this.rotation = {
            x: 0,
            y: 0
        }
    }

    /**
     * @param {string} group
     *
     * @return {boolean}
     */
    isGroupActive(group) {
        return (group === this.activeGroup);
    }

    /**
     * Nastavení aktivní skupiny
     *
     * @param {string} group
     */
    toggleGroup(group) {
        if (group !== this.activeGroup) {
            this.activeGroup = group;
        } else {
            this.activeGroup = 'general';
        }

        this.traverse(point => {
            point.hide();
        });
        this.traverseGroup(this.activeGroup, point => {
            point.show();
            point.update(this.rotation.x, this.rotation.y);
        });
    }

    /**
     * Aktualizace polohy bodů
     */
    update() {
        this.traverse(point => {
            point.update(this.rotation.x, this.rotation.y);
        });
    }

    /**
     * @param {function(Point)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let i = 0; i < this.points.length; ++i) {
            callback(this.points[i]);
        }
    }

    /**
     * @param {string}          group
     * @param {function(Point)} callback
     */
    traverseGroup(group, callback) {
        if (!this.groups.hasOwnProperty(group) || typeof callback !== 'function') {
            return;
        }
        for (let i = 0; i < this.groups[group].length; ++i) {
            callback(this.groups[group][i]);
        }
    }

    /**
     * @param {string}          type
     * @param {function(Point)} callback
     */
    traverseType(type, callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let i = 0; i < this.points.length; ++i) {
            if (this.points[i].type === type) {
                callback(this.points[i]);
            }
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @protected
     */
    _initTextures() {}

    /**
     * @protected
     */
    _initPoints() {
        let elements = document.querySelectorAll('.' + CLASS_MODEL_POINT);
        for (let i = 0; i < elements.length; ++i) {
            this._initPoint(elements[i]);
        }
    }

    /**
     * @param {Element} element
     *
     * @protected
     */
    _initPoint(element) {
        let point = Point.create(element, this.container, this.camera, this.objs);

        let groups = point.getGroups();
        for (let i = 0; i < groups.length; ++i) {
            this._addPointToGroup(point, groups[i]);
        }

        this.points.push(point);
    }

    /**
     * @param {Point}  point
     * @param {string} groupName
     *
     * @protected
     */
    _addPointToGroup(point, groupName) {
        if (!this.groups.hasOwnProperty(groupName)) {
            this.groups[groupName] = [];
        }
        this.groups[groupName].push(point);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * Callback události: controls changed
     *
     * @param {{}} event
     *
     * @protected
     */
    _callbackControlsChanged(event) {
        if (!this.points.length) {
            return;
        }

        let dir = new THREE.Vector3();
        this.camera.getWorldDirection(dir);
        dir.negate();

        let sphCoords = new THREE.Spherical();
        sphCoords.setFromVector3(dir);

        this.rotation.x = sphCoords.phi - Math.PI * 0.5;
        this.rotation.y = sphCoords.theta;
    }
}
/* global gv, THREE, TWEEN */

class PointsDistrict extends Points
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.OrbitControls}     controls
     * @param {Objs}                    objs
     */
    constructor(container, camera, controls, objs) {
        super(container, camera, controls, objs);


        /** @type {{}} */
        this.groups = {
            general: [],
            availableHousing: [],
            services: [],
            restaurants: [],
            relax: [],
            views: [],
            none: [],
        };

        this._initPoints();
        this._initTextures();
        this.toggleGroup('general');
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @private
     */
    _initTextures() {
        let dir = gv.content_url + '/files/3dmodel/district/textures/';
        this.textures = {
            'cafe': new THREE.TextureLoader().load(dir + 'icon_cafe.png'),
            'relax': new THREE.TextureLoader().load(dir + 'icon_relax.png'),
            'restaurant': new THREE.TextureLoader().load(dir + 'icon_restaurant.png'),
            'school': new THREE.TextureLoader().load(dir + 'icon_school.png'),
            'services': new THREE.TextureLoader().load(dir + 'icon_services.png'),
            'view': new THREE.TextureLoader().load(dir + 'icon_view.png'),
        };

        this.traverseType('interest', point => {
            point.setTexture(this.textures);
        });
        this.traverseType('view', point => {
            point.setTexture(this.textures);
        });
    }
}
/* global gv, THREE, TWEEN */

class PointsBuilding extends Points
{
    /**
     * Constructor
     *
     * @param {HTMLElement}             container
     * @param {THREE.PerspectiveCamera} camera
     * @param {THREE.OrbitControls}     controls
     * @param {Objs}                    objs
     */
    constructor(container, camera, controls, objs) {
        super(container, camera, controls, objs);


        /** @type {{}} */
        this.groups = {
            general: [],
            sections: [],
        };

        this._initPoints();
        this._initTextures();
        this.toggleGroup('sections');
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @private
     */
    _initTextures() {
        let dir = gv.content_url + '/files/3dmodel/building/textures/';
        this.textures = {
            'section1': new THREE.TextureLoader().load(dir + 'icon_section_1.png'),
            'section2': new THREE.TextureLoader().load(dir + 'icon_section_2.png'),
            'section3': new THREE.TextureLoader().load(dir + 'icon_section_3.png'),
            'section4': new THREE.TextureLoader().load(dir + 'icon_section_4.png'),
            'section5': new THREE.TextureLoader().load(dir + 'icon_section_5.png'),
            'section6': new THREE.TextureLoader().load(dir + 'icon_section_6.png'),
        };

        this.traverseType('interest', point => {
            point.setTexture(this.textures);
        });
    }
}
class Item
{
    /**
     * Constructor
     *
     * @param {Menu}    menu
     * @param {string}  name
     * @param {Element} element
     */
    constructor(menu, name, element) {
        /** @type {Menu} */
        this.menu = menu;

        /** @type {string} */
        this.name = name;

        /** @type {Element} */
        this.element = element;
        this.element.addEventListener('mouseup', this._callbackMouseUp.bind(this));

        /** @type {Boolean} */
        this.active = false;


        this.menu.addItem(this);
    }

    activate() {
        if (this.active) {
            return;
        }
        this.element.classList.add('active');
        this.active = true;
    }

    deactivate() {
        if (!this.active) {
            return;
        }
        this.element.classList.remove('active');
        this.active = false;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @param {MouseEvent} event
     *
     * @private
     */
    _callbackMouseUp(event) {
        this.menu.toggle(this.name);
    }
}
const CLASS_MODEL_SUBMENU_AVAILABLEHOUSING = 'js-model-submenu-availableHousing';

class ItemAvailableHousing extends Item
{
    /**
     * Constructor
     *
     * @param {Menu}    menu
     * @param {string}  name
     * @param {Element} element
     */
    constructor(menu, name, element) {
        super(menu, name, element);

        /** @type {Element} */
        this.submenu = document.querySelector('.' + CLASS_MODEL_SUBMENU_AVAILABLEHOUSING);
    }

    activate() {
        super.activate();
        this.submenu.style.display = 'block';
    }

    deactivate() {
        super.deactivate();
        this.submenu.style.display = 'none';
    }
}
class Menu
{
    /**
     * Constructor
     */
    constructor() {
        /** @type {{}} */
        this.items = {};
    }

    /**
     * @param {Item} item
     */
    addItem(item) {
        this.items[item.name] = item;
    }

    /**
     * @param {function(Item)} callback
     */
    traverse(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let name in this.items) {
            if (this.items.hasOwnProperty(name)) {
                callback(this.items[name]);
            }
        }
    }

    /**
     * @param {string} name
     */
    toggle(name) {
        this.traverse(item => {
            if (item.active) {
                item.deactivate();
            } else if (item.name === name) {
                item.activate();
            }
        });
    }
}
const OPTIMIZATION_INTERVAL = 2;
const OPTIMIZATION_LIMIT_MIN = 30;
const OPTIMIZATION_LIMIT_MAX = 50;

class Optimization {

    /**
     * Constructor
     *
     * @param {Model}                  model
     * @param {THREE.WebGLRenderer}    renderer
     * @param {THREE.DirectionalLight} light
     */
    constructor(model, renderer, light) {
        /** @type {Model} */
        this.model = model;

        /** @type {number} */
        this.counter = 0;

        /** @type {number} */
        this.level = 3;

        /** @type {number} */
        this.intervalId = window.setInterval(this._callbackInterval.bind(this), OPTIMIZATION_INTERVAL * 1000);

        /** @type {THREE.WebGLRenderer} */
        this.renderer = renderer;

        /** @type {THREE.DirectionalLight} */
        this.light = light;

        /** @type {{}[]} */
        this.opt = [
            // {
            //     shadowMapSize: 256,
            //     shadowRadius: 1
            // },
            {
                shadowMapSize: 512,
                shadowRadius: 1
            },
            {
                shadowMapSize: 1024,
                shadowRadius: 1
            },
            {
                shadowMapSize: 2048,
                shadowRadius: 1
            },
            {
                shadowMapSize: 4096,
                shadowRadius: 1.5
            },
            // {
            //     shadowMapSize: 8192,
            //     shadowRadius: 2
            // },
            // {
            //     shadowMapSize: 16384,
            //     shadowRadius: 4
            // },
        ];

        this._update();
    }

    update() {
        this.counter++;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @private
     */
    _callbackInterval() {
        let fps = this.counter / OPTIMIZATION_INTERVAL;
        if (!fps) {
            return;
        }
        // console.log('FPS:', fps);

        if (fps > OPTIMIZATION_LIMIT_MAX) {
            this._increaseLevel();
        } else if (fps < OPTIMIZATION_LIMIT_MIN) {
            this._decreaseLevel();
        }

        this.counter = 0;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {string} name
     *
     * @return {null|*}
     *
     * @private
     */
    _getOptValue(name) {
        if (this.opt[this.level].hasOwnProperty(name)) {
            return this.opt[this.level][name];
        }
        return null;
    }

    /**
     * @private
     */
    _increaseLevel() {
        let tmp = this.level;

        this.level++;
        if (this.level >= this.opt.length) {
            this.level = this.opt.length - 1;
        }

        if (this.level !== tmp) {
            this._update();
        }
    }

    /**
     * @private
     */
    _decreaseLevel() {
        let tmp = this.level;

        this.level--;
        if (this.level < 0) {
            this.level = 0;

            // TODO: vypínání modelu při nízkém FPS
            // this.model.stop();
            // return;
        }

        if (this.level !== tmp) {
            this._update();
        }
    }

    /**
     * @private
     */
    _update() {
        let shadowMapSize = this._getOptValue('shadowMapSize');
        if (shadowMapSize) {
            this.light.shadow.mapSize.width = shadowMapSize;
            this.light.shadow.mapSize.height = shadowMapSize;
        }

        let shadowRadius = this._getOptValue('shadowRadius');
        if (shadowRadius) {
            this.light.shadow.radius = shadowRadius;
        }

        if (this.light.shadow.map) {
            this.light.shadow.map.dispose();
            this.light.shadow.map = null;
        }

        if (this.level === 0) {
            this.renderer.shadowMap.autoUpdate = false;
            this.renderer.shadowMap.needsUpdate = true;
        } else {
            this.renderer.shadowMap.autoUpdate = true;
        }
        // this.renderer.clearTarget(this.light.shadow.map);
    }
}
const ID_LOADER = 'model-loader';
const ID_LOADER_PROGRESS_BAR = 'model-loader-progress-bar-value';

class ModelLoader
{
    /**
     * Constructor
     */
    constructor() {
        /** @type {HTMLElement} */
        this.container = document.getElementById(ID_LOADER);

        /** @type {HTMLElement} */
        this.progressBar = document.getElementById(ID_LOADER_PROGRESS_BAR);

        /** @type {int} */
        this.progress = 0;

        /** @type {int} */
        this.total = 0;
    }

    /**
     * Inicializace progressu
     *
     * @param {int} total
     * @param {int} progress
     */
    setProgress(total, progress = 0) {
        this.total = total;
        this.progress = progress;
    }

    show() {
        this.container.style.display = 'block';
    }

    hide() {
        this.progressBar.parentElement.style.display = 'none';
        this.container.classList.add('loaded');
        setTimeout(() => {
            this.container.style.display = 'none';
        }, 900)
    }

    /**
     * @param {int} step
     */
    updateProgress(step = 1) {
        this.progress += step;
        if (this.progress > this.total) {
            this.progress = this.total;
        }

        let progressPercent = this.progress / this.total * 100;
        this.progressBar.style.width = progressPercent + '%';

        if (this.progress >= this.total) {
            this.hide();
        }
    }
}
const ID_MODEL_CUT = 'model-cut';
const CUT_FADE_DURATION = 300;

class Intro {

    /**
     * Constructor
     *
     * @param {boolean}                 enabled
     * @param {THREE.Scene}             scene
     * @param {THREE.PerspectiveCamera} mainCamera
     * @param {Function}                callbackPlayed
     * @param {Function}                callbackStopped
     */
    constructor(enabled, scene, mainCamera, callbackPlayed, callbackStopped) {
        /** @type {boolean} */
        this.enabled = enabled;

        /** @type {boolean} */
        this.inProgress = false;

        /** @type {THREE.Scene} */
        this.scene = scene;

        /** @type {THREE.PerspectiveCamera} */
        this.mainCamera = mainCamera;

        /** @type {THREE.PerspectiveCamera} */
        this.activeCamera = this.mainCamera;

        /** @type {number} */
        this.activeCameraIndex = 0;

        /** @type {THREE.PerspectiveCamera[]} */
        this.cameras = [];

        /** @type {Animation[]} */
        this.animations = [];

        /** @type {Function} */
        this.callbackPlayed = callbackPlayed;

        /** @type {Function} */
        this.callbackStopped = callbackStopped;

        /** @type {HTMLElement} */
        this.cut = document.getElementById(ID_MODEL_CUT);
        if (this.enabled) {
            this.cut.style.opacity = '1';
            this.cut.classList.remove('d-none');
        }

        /** @type {{}} */
        this.mapNameIndex = {};
        let n = 0;
        for (let name in FILES_CAMERAS) {
            this.mapNameIndex[name] = n++;
            this.cameras.push(null);
            this.animations.push(null);
        }
    }

    /**
     * @param {string}                  name
     * @param {THREE.PerspectiveCamera} camera
     * @param {Animation}               animation
     */
    addCamera(name, camera, animation) {
        if (!this.enabled) {
            return;
        }

        if (!this.mapNameIndex.hasOwnProperty(name)) {
            return;
        }

        this.cameras[this.mapNameIndex[name]] = camera;
        this.animations[this.mapNameIndex[name]] = animation;
    }

    getActiveCamera() {
        return this.activeCamera;
    }

    play() {
        if (!this.enabled) {
            return;
        }

        this.activeCameraIndex = 0;
        this.animations[this.activeCameraIndex].reset();

        this._cutFadeInOut(function(){
            if (typeof this.callbackPlayed === 'function') {
                this.callbackPlayed();
            }
            this._play();
            this.inProgress = true;
        }.bind(this));
    }

    stop() {
        if (!this.enabled) {
            return;
        }

        this._cutFadeInOut(function(){
            if (this.activeCameraIndex < this.animations.length) {
                this.animations[this.activeCameraIndex].pause();
            }

            this.activeCamera = this.mainCamera;

            if (typeof this.callbackStopped === 'function') {
                this.callbackStopped();
            }

            this.inProgress = false;
        }.bind(this));
    }

    /**
     * @return {boolean}
     */
    isPlaying() {
        if (!this.enabled) {
            return false;
        }
        return this.inProgress;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @private
     */
    _play() {
        if (this.activeCameraIndex >= this.cameras.length) {
            this.stop();
            return;
        }

        this.activeCamera = this.cameras[this.activeCameraIndex];
        this.animations[this.activeCameraIndex].setCallbackEnded(this._callbackAnimationEnded.bind(this));
        this.animations[this.activeCameraIndex].play();
    }

    /**
     * @private
     */
    _cutFadeIn() {
        this.cut.classList.remove('d-none');
        this.cut.style.opacity = '1';
    }

    /**
     * @private
     */
    _cutFadeOut() {
        this.cut.style.opacity = '0';

        window.setTimeout(function(){
            this.cut.classList.add('d-none');
        }.bind(this), CUT_FADE_DURATION);
    }

    /**
     * @param {function} callback
     *
     * @private
     */
    _cutFadeInOut(callback) {
        if (!this.cut.classList.contains('d-none')) {
            callback();
            this._cutFadeOut();
            return;
        }

        this._cutFadeIn();
        window.setTimeout(function(){
            callback();
            this._cutFadeOut();
        }.bind(this), CUT_FADE_DURATION);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * @private
     */
    _callbackAnimationEnded() {
        this.activeCameraIndex++;
        this._play();
    }
}
const ID_MODEL = 'model';
const ID_MODEL_WRAPPER = 'model-wrapper';
const ID_MODEL_UNAVAILABLE = 'model-unavailable';

/* global THREE, TWEEN */

/**
 * @const FILES
 * @type {Object}
 */

/**
 * Základní třída pro modely
 */
class Model
{
    /**
     * Constructor
     *
     * @param {{}}      options
     * @param {boolean} debug
     */
    constructor(options = {}, debug = false) {
        /** @type {{}} */
        this.options = options;

        /** @type {boolean} */
        this.debug = debug;

        /** @type {boolean} */
        this.initialized = false;

        /** @type {boolean} */
        this.started = false;

        /** @type {HTMLElement} */
        this.container = document.getElementById(ID_MODEL);

        /** @type {THREE.Scene} */
        this.scene = null;

        /** @type {THREE.WebGLRenderer} */
        this.renderer = null;

        /** @type {THREE.PerspectiveCamera} */
        this.camera = null;

        /** @type {THREE.Raycaster} */
        this.raycaster = null;

        /** @type {THREE.OrbitControls} */
        this.controls = null;

        /** @type {Mouse} */
        this.mouse = new Mouse(this.container);

        /** @type {THREE.DirectionalLight} */
        this.light = null;

        /** @type {Objs} */
        this.objects = new Objs(this.container);

        /** @type {Animations} */
        this.animations = new Animations();

        /** @type {Compass} */
        this.compass = null;

        /** @type {Points} */
        this.points = null;

        /** @type {Stats} */
        this.stats = null;

        /** @type {Optimization} */
        this.optimization = null;

        /** @type {ModelLoader} */
        this.loader = new ModelLoader();

        /** @type {{}} */
        this.opt = {};

        /** @type {{}} */
        this.loadedModels = {};

        /** @type {THREE.Vector3} */
        this.prevControlsTarget = null;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // spuštění aplikace a detekce dostupnosti

    /**
     * Spuštění aplikace
     */
    run() {
        if (!IntersectionObserver) {
            this._run();
            return;
        }

        let observer = new IntersectionObserver(this._callbackObserver.bind(this), {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });
        observer.observe(this.container);
    }

    /**
     * Zastavení aplikace
     */
    stop() {
        this.started = false;

        let wrapper = document.getElementById(ID_MODEL_WRAPPER);
        wrapper.style.display = 'none';

        let unavailable = document.getElementById(ID_MODEL_UNAVAILABLE);
        unavailable.style.display = 'flex';
    }

    /**
     * @private
     */
    _run() {
        if (!this._isAvailable()) {
            this.stop();
            return;
        }

        this.initialized = true;
        this.started = true;

        this._initOptions();
        this._initScene();
        this._initDOM();
        this._initGeometry();

        this._render();
    }

    /**
     * Detekce dostupnosti WebGL
     *
     * @return {boolean} TRUE, pokud je WebGL dostupné
     *
     * @private
     */
    _isAvailable() {
        try {
            let canvas = document.createElement('canvas');
            return !! (window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
        } catch (e) {
            return false;
        }
    }

    /**
     * Inicializace modelu
     *
     * @param {[IntersectionObserverEntry]} entries
     * @param {IntersectionObserver}        observer
     *
     * @protected
     */
    _callbackObserver(entries, observer) {
        if (!this.initialized && entries.length && entries[0].isIntersecting) {
            this._run();
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @protected
     */
    _initOptions() {
        this.opt = {
            scene: {
                background: new THREE.Color('rgb(0, 0, 0)')
            },
            renderer: {
                antialias: (window.devicePixelRatio <= 1),
                gammaFactor: 2.2
            },
            camera: {
                fov: 60,
                aspect: this.container.clientWidth / this.container.clientHeight,
                near: 1,
                far: 2000,
                position: new THREE.Vector3(-100, 50, -200),
            },
            control: {
                target: new THREE.Vector3(-180, 0, -160),
                limits: {
                    center: new THREE.Vector2(0, 0),
                    radius: 0
                },
                props: {
                    screenSpacePanning: false,
                    enableDamping: true,
                    dampingFactor: 0.15,
                    rotateSpeed: 0.1,
                    panSpeed: 0.2,
                }
            },
            sun: {
                position: new THREE.Vector3(200, 300, 100),
                target: {
                    position: new THREE.Vector3(0, 0, 0)
                },
                shadow: {
                    enabled: !this.options.testing,
                    mapSize: 4096,
                    zoomFactor: 1.5,
                    zoomDelta: 0,
                    cameraSize: 40,
                }
            },
            fog: {
                enabled: false,
                color: new THREE.Color('rgb(0, 0, 0)'),
                near: 3500,
                far: 8500
            },
            geometry: {
                scale: 0.001,
                models: {
                    pickable: {}
                }
            },
            compass: {
                north: new THREE.Vector3(0.1262, 0, -0.9920)
            },
            views: {}
        };
    }

    /**
     * @protected
     */
    _initScene() {
        // scene
        this.scene = new THREE.Scene();
        this.scene.background = this.opt.scene.background;

        // renderer
        this.renderer = new THREE.WebGLRenderer({
            antialias: this.opt.renderer.antialias
        });
        this.renderer.setPixelRatio(window.devicePixelRatio ? window.devicePixelRatio : 1);
        this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
        this.renderer.gammaOutput = true;
        this.renderer.gammaFactor = this.opt.renderer.gammaFactor;
        this.renderer.shadowMap.enabled = !this.options.testing;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.container.appendChild(this.renderer.domElement);

        // camera
        this.camera = new THREE.PerspectiveCamera(
            this.opt.camera.fov, this.opt.camera.aspect, this.opt.camera.near, this.opt.camera.far
        );
        this.camera.position.copy(this.opt.camera.position);

        // raycaster
        this.raycaster = new THREE.Raycaster();

        // control
        this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement);
        this.controls.target.copy(this.opt.control.target);
        for (let prop in this.opt.control.props) {
            if (this.opt.control.props.hasOwnProperty(prop)) {
                this.controls[prop] = this.opt.control.props[prop];
            }
        }
        this.prevControlsTarget = this.controls.target.clone();
        this.controls.addEventListener('change', this._callbackControlsChanged.bind(this));

        // lights
        this.light = new THREE.DirectionalLight(0xffffff, 0.7);
        this.light.position.copy(this.opt.sun.position);
        this.light.castShadow = !this.options.testing;
        this.light.shadow.mapSize.width = this.opt.sun.shadow.mapSize;
        this.light.shadow.mapSize.height = this.opt.sun.shadow.mapSize;
        this.light.shadow.camera.near = 0.5;
        this.light.shadow.camera.far = 5000;
        this.light.shadow.camera.left = -this.opt.sun.shadow.cameraSize;
        this.light.shadow.camera.bottom = -this.opt.sun.shadow.cameraSize;
        this.light.shadow.camera.right = this.opt.sun.shadow.cameraSize;
        this.light.shadow.camera.top = this.opt.sun.shadow.cameraSize;
        // this.light.shadow.bias = 0.0001;

        this.light.target = new THREE.Object3D();
        this.light.target.position.copy(this.opt.sun.target.position);
        this.light.position.set(
            this.light.target.position.x + this.opt.sun.position.x,
            this.light.target.position.y + this.opt.sun.position.y,
            this.light.target.position.z + this.opt.sun.position.z
        );
        this.scene.add(this.light.target);

        this.scene.add(this.light);
        // this.scene.add(new THREE.CameraHelper(this.light.shadow.camera));

        this.scene.add(new THREE.AmbientLight(0xffffff, 0.3));

        // kompas
        this.compass = new Compass(this.opt.compass.north, this.camera);

        // fog
        if (this.opt.fog.enabled) {
            this.scene.fog = new THREE.Fog(this.opt.fog.color, this.opt.fog.near, this.opt.fog.far);
        }

        // stats
        if (this.debug) {
            this.stats = new Stats();
            this.container.appendChild(this.stats.dom);
        }
    }

    /**
     * @protected
     */
    _initDOM() {
        window.addEventListener('resize', this._callbackWindowResized.bind(this));
    }

    /**
     * @protected
     */
    _initGeometry() {
        this.loader.show();
        this.scene.add(this.objects.getObject());

        for (let name in FILES) {
            if (FILES[name].slice(-4) === '.zip') {
                this._loadArchive(FILES[name], name);
            } else {
                this._loadModel(FILES[name], name);
            }
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: načtení modelů

    /**
     * @param {string} url
     * @param {string} name
     *
     * @protected
     */
    _loadModel(url, name) {
        this.loadedModels[name] = false;

        let loader = new THREE.GLTFLoader();
        loader.load(
            url,
            this._callbackModelLoaded.bind(this, name),
            function(xhr) {},
            this._callbackModelNotLoaded.bind(this, name)
        );
    }

    /**
     * @param {string} url
     * @param {string} name
     *
     * @protected
     */
    _loadArchive(url, name) {
        if (
            this.options.testing && (
                // name === 'marinaNOVA' ||
                name === 'marina_island' ||
                name === 'marina_prague' ||
                name === 'ulice'
                // name === 'okoli_siroke'
            )
        ) {
            this.loader.updateProgress();
            return;
        }

        this.loadedModels[name] = false;

        new THREE.ZipLoadingManager
            .uncompress(
                url, ['.gltf'],
                () => {
                    // console.log('onLoad');
                },
                (url, itemsLoaded, itemsTotal) => {
                    // console.log('onProgress:', itemsLoaded, itemsTotal, url);
                },
                url => {
                    console.log(`model '${name}' (${url}) se nepodařilo načíst`);
                }
            )
            .then(zip => {
                let loader = new THREE.GLTFLoader(zip.manager);
                loader.load(
                    zip.urls[0],
                    this._callbackModelLoaded.bind(this, name),
                    function(xhr) {},
                    this._callbackModelNotLoaded.bind(this, name)
                );
            });
    }

    /**
     * @param {string} name
     * @param {Object} gltf
     *
     * @protected
     */
    _callbackModelLoaded(name, gltf) {
        let object = gltf.scene;
        object.scale.set(this.opt.geometry.scale, this.opt.geometry.scale, this.opt.geometry.scale);

        let obj = new ObjModel(name, object, this._isPickable(name));
        this.objects.add(obj);

        this.loadedModels[name] = true;
        if (this._checkAllModelsLoaded()) {
            this._callbackAllModelsLoaded();
        }

        this.loader.updateProgress();
    }

    /**
     * @param {string} name
     * @param {string} error
     *
     * @protected
     */
    _callbackModelNotLoaded(name, error) {
        console.log(`model '${name}' se nepodařilo načíst:`, error);
        this.loader.updateProgress();
    }

    /**
     * @param {string} name
     *
     * @returns {boolean}
     *
     * @protected
     */
    _isPickable(name) {
        return (this.opt.geometry.models.pickable.hasOwnProperty(name) && this.opt.geometry.models.pickable[name]);
    }

    /**
     * @protected
     */
    _checkAllModelsLoaded() {
        for (let name in this.loadedModels) {
            if (!this.loadedModels.hasOwnProperty(name)) {
                continue;
            }
            if (!this.loadedModels[name]) {
                return false;
            }
        }
        return true;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: update scene

    /**
     * @protected
     */
    _render() {
        if (!this.started) {
            return;
        }

        requestAnimationFrame(this._render.bind(this));
        this._update();
        this.renderer.render(this.scene, this.camera);
    }

    /**
     * @protected
     */
    _update() {
        this._updateControls();
        this._updatePicking();
        this._updateAnimations();
        this._updateShadows();

        if (this.stats) {
            this.stats.update();
        }
        if (this.optimization) {
            this.optimization.update();
        }
    }

    /**
     * @protected
     */
    _updateControls() {
        this.controls.update();
    }

    /**
     * @protected
     */
    _updatePicking() {
        if (this.mouse.moved()) {
            this.raycaster.setFromCamera(this.mouse.getCoordinates(), this.camera);
            this.objects.beginHover(this.raycaster.intersectObjects(this.objects.getPickableObjects(), true));
        }
        if (this.mouse.clicked(0) && this.objects.isHover()) {
            this.objects.select(this.objects.getHovered());
            let selectedObj = this.objects.getSelected();
            if (selectedObj) {
                this._callbackObjSelected(selectedObj);
            }
        }
    }

    /**
     * @protected
     */
    _updateAnimations() {
        this.animations.update();
        TWEEN.update();
    }

    /**
     * @protected
     */
    _updateShadows() {
        this.light.target.position.set(this.controls.target.x, 0, this.controls.target.z);
        this.light.position.set(
            this.light.target.position.x + this.opt.sun.position.x,
            this.light.target.position.y + this.opt.sun.position.y,
            this.light.target.position.z + this.opt.sun.position.z
        );

        let zoom = this.camera.position.distanceTo(this.controls.target);
        let shadowCameraSize = zoom * this.opt.sun.shadow.zoomFactor + this.opt.sun.shadow.zoomDelta;
        this.light.shadow.camera.left = -shadowCameraSize;
        this.light.shadow.camera.bottom = -shadowCameraSize;
        this.light.shadow.camera.right = shadowCameraSize;
        this.light.shadow.camera.top = shadowCameraSize;
        this.light.shadow.camera.updateProjectionMatrix();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: views

    /**
     * @param {string} name     název pohledu
     * @param {number} duration trvání animace v sekundách
     *
     * @protected
     */
    _setView(name, duration = 1) {
        if (!this.opt.views.hasOwnProperty(name)) {
            return;
        }

        let view = this.opt.views[name];
        let tween;

        tween = new TWEEN.Tween(this.controls.target)
            .to({x: view.target.x, y: this.controls.target.y, z: view.target.y}, duration * 1000)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();

        tween = new TWEEN.Tween(this.camera.position)
            .to({x: view.position.x, y: view.position.y, z: view.position.z}, duration * 1000)
            .easing(TWEEN.Easing.Quadratic.InOut);
        tween.start();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * Callback události: velikosti okna změněna
     *
     * @protected
     */
    _callbackWindowResized() {
        this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);

        this.compass.update();
        this.points.update();
    }

    /**
     * Callback události: všechny modely nahrány
     *
     * @protected
     */
    _callbackAllModelsLoaded() {
        if (!this.options.testing) {
            this.optimization = new Optimization(this, this.renderer, this.light);
        }

        this.points.update();
    }

    /**
     * Callback události: vybrán objekt
     *
     * @param {Obj} obj
     *
     * @protected
     */
    _callbackObjSelected(obj) {}

    /**
     * Callback události: controls changed
     *
     * @param {{}} event
     *
     * @protected
     */
    _callbackControlsChanged(event) {
        if (this.opt.control.limits.radius) {
            let point = new THREE.Vector2(this.controls.target.x, this.controls.target.z);
            if (Common.isPointInsideCircle(point, this.opt.control.limits.center, this.opt.control.limits.radius)) {
                this.prevControlsTarget = this.controls.target.clone();
            } else {
                this.controls.target = this.prevControlsTarget.clone();
            }
        }

        this.compass.update();
        this.points.update();

        // console.log('position', this.camera.position);
        // console.log('target', this.controls.target);
        // console.log('---');
    }
}
const CLASS_MODEL_MENU_AVAILABLEHOUSING = 'js-model-menu-availableHousing';
const CLASS_MODEL_MENU_SERVICES = 'js-model-menu-services';
const CLASS_MODEL_MENU_RESTAURANTS = 'js-model-menu-restaurants';
const CLASS_MODEL_MENU_RELAX = 'js-model-menu-relax';
const CLASS_MODEL_MENU_VIEWS = 'js-model-menu-views';
const CLASS_MODEL_COUNT_AVAILABLE = 'js-model-count-available';

/* global gv, THREE, TWEEN */

/**
 * @const URL_MODEL_BUILDING
 * @type {string}
 */

/**
 * @const DATA
 * @type {{}}
 */

/**
 * @const CS
 * @type {boolean}
 */

/**
 * @const EN
 * @type {boolean}
 */

/**
 * @const FILES_CAMERAS
 * @type {Object}
 */

/**
 * Model čtvrti
 */
class ModelDistrict extends Model
{
    /**
     * Constructor
     *
     * @param {{}}      options
     * @param {boolean} debug
     */
    constructor(options = {}, debug = false) {
        super(options, debug);

        /** @type {Menu} */
        this.menu = new Menu();
        this._initMenu();

        /** @type {{}} */
        this.data = DATA;

        /** @type {Intro} */
        this.intro = null;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // akce

    /**
     * Akce: dostupné bydlení
     */
    actionAvailableHousing() {
        this.points.toggleGroup('availableHousing');
    }

    /**
     * Akce: služby a obchody
     */
    actionServices() {
        let group = 'services';
        this.points.toggleGroup(group);
        if (this.points.isGroupActive(group)) {
            this._setView('poi');
        }
    }

    /**
     * Akce: restaurace
     */
    actionRestaurants() {
        let group = 'restaurants';
        this.points.toggleGroup(group);
        if (this.points.isGroupActive(group)) {
            this._setView('poi');
        }
    }

    /**
     * Akce: relax
     */
    actionRelax() {
        let group = 'relax';
        this.points.toggleGroup(group);
        if (this.points.isGroupActive(group)) {
            this._setView('poi');
        }
    }

    /**
     * Akce: výhledy
     */
    actionViews() {
        this.points.toggleGroup('views');
    }

    /**
     * Akce: přechod do modelu budovy
     */
    actionModelBuilding() {
        window.location.href = URL_MODEL_BUILDING;
    }

    /**
     * Akce: pohled od řeky
     */
    actionViewRiver() {
        this._setView('river');
    }

    /**
     * Akce: pohled z břehu
     */
    actionViewRiverside() {
        this._setView('riverside');
    }

    /**
     * Akce: pohled z balkónu
     */
    actionViewBalcony() {
        this._setView('balcony');
    }

    /**
     * Akce: pohled Jankovcova
     */
    actionViewJankovcova() {
        this._setView('jankovcova');
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @protected
     */
    _initOptions() {
        super._initOptions();

        this.opt.scene.background = new THREE.Color('rgb(192, 213, 220)');

        this.opt.camera.far = 2000;
        this.opt.camera.position = new THREE.Vector3(-118, 56, -220);
        this.opt.control.target = new THREE.Vector3(-168, 12, -167);
        this.opt.control.props.minDistance = 5;
        this.opt.control.props.maxDistance = 150;
        this.opt.control.props.minPolarAngle = 0;
        this.opt.control.props.maxPolarAngle = Math.PI / 2;
        this.opt.control.limits.center = new THREE.Vector2(0, 0);
        this.opt.control.limits.radius = 350;

        this.opt.fog.enabled = true;
        // this.opt.fog.color = 'rgb(192, 213, 220)';
        this.opt.fog.color = 'rgb(213, 226, 231)';
        this.opt.fog.near = 450;
        this.opt.fog.far = 900;

        this.opt.geometry.models.pickable = {
            'marinaNOVA': true
        };

        this.opt.views = {
            poi: {
                position: new THREE.Vector3(-250, 80, -170),
                target: new THREE.Vector2(-153,-80)
            },
            river: {
                position: new THREE.Vector3(-100, 12, -232),
                target: new THREE.Vector2(-168, -167)
            },
            riverside: {
                position: new THREE.Vector3(-25, 15, -280),
                target: new THREE.Vector2(-100, -175)
            },
            balcony: {
                position: new THREE.Vector3(-130, 39, -147),
                target: new THREE.Vector2(0, -100)
            },
            jankovcova: {
                position: new THREE.Vector3(-180, 12, -64),
                target: new THREE.Vector2(-158, -161)
            }
        };
    }

    /**
     * @protected
     */
    _initScene() {
        super._initScene();

        // points of interrests
        this.points = new PointsDistrict(this.container, this.camera, this.controls, this.objects);

        // intro
        this.intro = new Intro(
            !this.options.disableIntro, this.scene, this.camera,
            this._callbackIntroPlayed.bind(this), this._callbackIntroStopped.bind(this)
        );
        this.container.addEventListener('click', this._callbackIntroUserAction.bind(this));

        // skybox
        let loader = new THREE.CubeTextureLoader();
        loader.setPath(gv.content_url + '/files/3dmodel/district/textures/');
        this.scene.background = loader.load(['px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg']);
    }

    /**
     * @protected
     */
    _initGeometry() {
        let filesCount = 0;
        for (let name in FILES) {
            filesCount++;
        }
        if (!this.options.disableIntro) {
            for (let name in FILES_CAMERAS) {
                filesCount++;
            }
        }
        this.loader.setProgress(filesCount);

        super._initGeometry();

        // animace kamery
        if (!this.options.disableIntro) {
            for (let name in FILES_CAMERAS) {
                this._loadModelCamera(FILES_CAMERAS[name], name);
            }
        }

        // grid
        // let grid = new THREE.GridHelper(2500, 50, 0xffffff, 0xbbbbbb);
        // grid.translateY(30);
        // this.scene.add(grid);
    }

    /**
     * @private
     */
    _initMenu() {
        let element;

        element = document.querySelector('.' + CLASS_MODEL_MENU_AVAILABLEHOUSING);
        new ItemAvailableHousing(this.menu, 'availableHousing', element);

        element = document.querySelector('.' + CLASS_MODEL_MENU_SERVICES);
        new Item(this.menu, 'services', element);

        element = document.querySelector('.' + CLASS_MODEL_MENU_RESTAURANTS);
        new Item(this.menu, 'restaurants', element);

        element = document.querySelector('.' + CLASS_MODEL_MENU_RELAX);
        new Item(this.menu, 'relax', element);

        element = document.querySelector('.' + CLASS_MODEL_MENU_VIEWS);
        new Item(this.menu, 'views', element);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: načtení modelů

    /**
     * @param {string} url
     * @param {string} name
     *
     * @protected
     */
    _loadModelCamera(url, name) {
        this.loadedModels[name] = false;

        let loader = new THREE.GLTFLoader();
        loader.load(
            url,
            this._callbackModelCameraLoaded.bind(this, name),
            function(xhr) {},
            this._callbackModelNotLoaded.bind(this, name)
        );
    }

    /**
     * @param {string} name
     * @param {Object} gltf
     *
     * @protected
     */
    _callbackModelCameraLoaded(name, gltf) {
        if (!gltf.cameras.length || !gltf.animations.length || !gltf.animations[0].tracks.length) {
            this.loader.updateProgress();
            return;
        }

        // camera
        gltf.cameras[0].scale.set(this.opt.geometry.scale, this.opt.geometry.scale, this.opt.geometry.scale);
        let camera = new THREE.PerspectiveCamera(
            this.opt.camera.fov, this.opt.camera.aspect, this.opt.camera.near, this.opt.camera.far
        );
        camera.position.copy(gltf.cameras[0].position);
        this.scene.add(camera);

        // animation
        let clip = gltf.animations[0];
        for (let i = 0; i < clip.tracks[0].values.length; ++i) {
            clip.tracks[0].values[i] *= this.opt.geometry.scale;
        }
        let animation = new AnimationCamera(camera, clip);
        this.animations.setAnimation('camera:' + name, animation);

        this.intro.addCamera(name, camera, animation);

        this.loadedModels[name] = true;
        if (this._checkAllModelsLoaded()) {
            this._callbackAllModelsLoaded();
        }

        this.loader.updateProgress();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: update scene

    /**
     * @protected
     */
    _render() {
        if (!this.started) {
            return;
        }

        requestAnimationFrame(this._render.bind(this));
        this._update();
        this.renderer.render(this.scene, this.intro.getActiveCamera());
    }

    /**
     * @protected
     */
    _updatePicking() {
        if (this.intro.isPlaying()) {
            this.mouse.moved();
            this.mouse.clicked(0);
            return;
        }

        super._updatePicking();
    }

    /**
     * @protected
     */
    _updateShadows() {
        this.light.target.position.set(this.controls.target.x, 0, this.controls.target.z);
        this.light.position.set(
            this.light.target.position.x + this.opt.sun.position.x,
            this.light.target.position.y + this.opt.sun.position.y,
            this.light.target.position.z + this.opt.sun.position.z
        );

        let zoom = this.intro.getActiveCamera().position.distanceTo(this.controls.target);
        let shadowCameraSize = zoom * this.opt.sun.shadow.zoomFactor + this.opt.sun.shadow.zoomDelta;
        this.light.shadow.camera.left = -shadowCameraSize;
        this.light.shadow.camera.bottom = -shadowCameraSize;
        this.light.shadow.camera.right = shadowCameraSize;
        this.light.shadow.camera.top = shadowCameraSize;
        this.light.shadow.camera.updateProjectionMatrix();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * Callback události: všechny modely nahrány
     *
     * @protected
     */
    _callbackAllModelsLoaded() {
        let obj = this.objects.getObj('marinaNOVA');
        if (obj) {
            let element = document.getElementById('building-box-marina-nova');
            if (this.data.buildings.hasOwnProperty('nova')) {
                element.querySelector('.' + CLASS_MODEL_COUNT_AVAILABLE).textContent = this.data.buildings.nova.countAvailable;
            }
            obj.setElement(element);
        }

        super._callbackAllModelsLoaded();

        if (this.options.hasOwnProperty('filterCategory')) {
            this.menu.toggle(this.options.filterCategory);
            switch (this.options.filterCategory) {
                case 'availableHousing':
                    this.actionAvailableHousing();
                    break;
                case 'services':
                    this.actionServices()
                    break;
                case 'restaurants':
                    this.actionRestaurants()
                    break;
                case 'relax':
                    this.actionRelax()
                    break;
                case 'views':
                    this.actionViews()
                    break;
            }
        }

        this.intro.play();
    }

    /**
     * Callback události: vybrán objekt
     *
     * @param {Obj} obj
     *
     * @protected
     */
    _callbackObjSelected(obj) {
        if (!this.opt.geometry.models.pickable.hasOwnProperty(obj.getName()) || this.intro.isPlaying()) {
            return;
        }

        window.location.href = URL_MODEL_BUILDING;
    }

    /**
     * @private
     */
    _callbackIntroPlayed() {
        this.controls.enabled = false;
        this.points.toggleGroup('none');


        // fog
        if (this.opt.fog.enabled) {
            this.scene.fog = null;
        }


        // ovládací prvky na stránce
        let element, elements;

        element = document.getElementById('model-intro-info');
        element.classList.remove('d-none');
        element.addEventListener('click', this._callbackIntroUserAction.bind(this));

        element = document.getElementById('model-compass');
        element.classList.add('d-none');

        element = document.getElementById('model-view-box');
        element.classList.add('d-none');

        elements = document.getElementsByClassName('js-model-point');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.add('d-none');
        }

        elements = document.getElementsByClassName('model-building-box');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.add('d-none');
        }

        elements = document.getElementsByClassName('model-controls');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.add('d-none');
        }
    }

    /**
     * @private
     */
    _callbackIntroStopped() {
        this.controls.enabled = true;
        this.points.toggleGroup('general');


        // fog
        if (this.opt.fog.enabled) {
            this.scene.fog = new THREE.Fog(this.opt.fog.color, this.opt.fog.near, this.opt.fog.far);
        }


        // ovládací prvky na stránce
        let element, elements;

        element = document.getElementById('model-intro-info');
        element.classList.add('d-none');

        element = document.getElementById('model-compass');
        element.classList.remove('d-none');

        element = document.getElementById('model-view-box');
        element.classList.remove('d-none');

        elements = document.getElementsByClassName('js-model-point');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.remove('d-none');
        }

        elements = document.getElementsByClassName('model-building-box');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.remove('d-none');
        }

        elements = document.getElementsByClassName('model-controls');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.remove('d-none');
        }

        elements = document.getElementsByClassName('model-instruction');
        for (let i = 0; i < elements.length; ++i) {
            elements[i].classList.add('active');
        }

    }

    /**
     * @private
     */
    _callbackIntroUserAction(event) {
        if (this.intro.isPlaying()) {
            this.intro.stop();
        }
    }
}
/* global THREE, TWEEN */

/**
 * @const URL_MODEL_DISTRICT
 * @type {string}
 */

/**
 * @const URL_DETAIL
 * @type {string}
 */

/**
 * @const DATA
 * @type {{}}
 */

/**
 * @const CS
 * @type {boolean}
 */

/**
 * @const EN
 * @type {boolean}
 */

/**
 * @const FILES_PLANS
 * @type {Object}
 */

/**
 * Model budovy
 */
class ModelBuilding extends Model
{
    /**
     * Constructor
     *
     * @param {{}}      options
     * @param {boolean} debug
     */
    constructor(options = {}, debug = false) {
        super(options, debug);

        /** @type Building */
        this.building = null;

        /** @type {{}} */
        this.data = DATA;

        /** @type {{}} */
        this.floorBtns = {};
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // akce

    /**
     * Akce: pohled z vrchu
     */
    actionViewTop() {
        this._setView('top');
    }

    /**
     * Akce: pohled z ulice
     */
    actionViewStreet() {
        this._setView('street');
    }

    /**
     * Akce: pohled od řeky
     */
    actionViewRiver() {
        this._setView('river');
    }

    /**
     * Akce: celá budova
     */
    actionWholeBuilding() {
        this.building.deactivateFloor();
    }

    /**
     * Akce: podlaží
     *
     * @param {number} floorNo
     */
    actionFloor(floorNo) {
        this.building.activateFloor(floorNo);
    }

    /**
     * Akce: další podlaží
     */
    actionNextFloor() {
        this.building.activateNextFloor();
    }

    /**
     * Akce: předchozí podlaží
     */
    actionPrevFloor() {
        this.building.activatePrevFloor();
    }

    /**
     * Akce: prohlídka čtvrti
     */
    actionModelDistrict() {
        window.location.href = URL_MODEL_DISTRICT;
    }

    /**
     * Akce: zobrazit/schovat sekce
     */
    actionToggleSections(event) {
        this.points.toggleGroup('sections');

        let element = event.target || event;
        if (this.points.isGroupActive('sections')) {
            element.querySelector('.active').classList.remove('d-none');
            element.querySelector('.inactive').classList.add('d-none');
        } else {
            element.querySelector('.active').classList.add('d-none');
            element.querySelector('.inactive').classList.remove('d-none');
        }
    }

    /**
     * Akce:
     */
    actionDebug() {
        // let bbLower = new THREE.Box3();
        // let bbUpper = new THREE.Box3();
        //
        // this.building.traverseFloors(this.building.minFloorNo, this.building.maxFloorNo, floor => {
        //     if (floor.obj.state === OBJ_STATE_NORMAL) {
        //         bbLower = bbLower.expandByObject(floor.obj.getObject());
        //     } else {
        //         bbUpper = bbUpper.expandByObject(floor.obj.getObject());
        //     }
        // });
        //
        // this.scene.add(new THREE.Box3Helper(bbLower, 0x0000ff));
        // this.scene.add(new THREE.Box3Helper(bbUpper, 0xff0000));
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: inicializace

    /**
     * @protected
     */
    _initOptions() {
        super._initOptions();

        this.opt.scene.background = new THREE.Color('rgb(245, 245, 245)');

        this.opt.camera.far = 2000;
        this.opt.camera.position = new THREE.Vector3(-118, 56, -220);
        this.opt.control.target = new THREE.Vector3(-168, 16, -167);
        this.opt.control.props.minDistance = 5;
        this.opt.control.props.maxDistance = 150;
        this.opt.control.props.minPolarAngle = 0;
        this.opt.control.props.maxPolarAngle = Math.PI / 2;
        this.opt.control.limits.center = new THREE.Vector2(-168, -167);
        this.opt.control.limits.radius = 80;

        this.opt.sun.position = new THREE.Vector3(200, 300, 100);
        this.opt.sun.target.position = new THREE.Vector3(-180, 0, -160);
        this.opt.sun.shadow.zoomFactor = 2;
        this.opt.sun.shadow.zoomDelta = 10;

        this.opt.fog.enabled = true;
        this.opt.fog.color = 'rgb(245, 245, 245)';
        this.opt.fog.near = 400;
        this.opt.fog.far = 600;

        this.opt.geometry.models.pickable = {
            'NOVA_1NP': true,
            'NOVA_2NP': true,
            'NOVA_3NP': true,
            'NOVA_4NP': true,
            'NOVA_5NP': true,
            'NOVA_6NP': true,
            'NOVA_7NP': true,
            'NOVA_8NP': true,
            'NOVA_9NP': true,
            'NOVA_10NP': true
        };

        this.opt.views = {
            top: {
                position: new THREE.Vector3(-166.83785519373367, 112.93948369747461, -167.4592025607423),
                target: new THREE.Vector2(-168, -167)
            },
            street: {
                position: new THREE.Vector3(-183, 45, -64),
                target: new THREE.Vector2(-168, -167)
            },
            river: {
                position: new THREE.Vector3(-118, 56, -220),
                target: new THREE.Vector2(-168, -167)
            }
        };

        let targetYOffset = 1;
        let labelYOffset = 5;
        this.opt.building = {
            floors: {
                1: {
                    obj: 'NOVA_1NP',
                    objPlan: 'NOVA_1NP-pudorys',
                    targetY: 3.057 + targetYOffset,
                    flats: {
                        '611': true,
                        '612': true,
                        '613': true,
                        '614': true,
                        '615': true,
                        '616': true,
                        '617': true,
                        '618': true,
                    },
                    commerces: {
                        'K1': true,
                        'K2': true,
                        'K3': true,
                        'K4': true,
                        'K5': true,
                        'K6': true,
                    },
                    label: {
                        position: new THREE.Vector3(-195, 3.057 + labelYOffset, -155)
                    }
                },
                2: {
                    obj: 'NOVA_2NP',
                    objPlan: 'NOVA_2NP-pudorys',
                    targetY: 10.958 + targetYOffset,
                    flats: {
                        '121': true,
                        '122': true,
                        '123': true,
                        '124': true,
                        '221': true,
                        '222': true,
                        '223': true,
                        '224': true,
                        '225': true,
                        '321': true,
                        '322': true,
                        '323': true,
                        '324': true,
                        '325': true,
                        '421': true,
                        '422': true,
                        '423': true,
                        '424': true,
                        '425': true,
                        '426': true,
                        '521': true,
                        '522': true,
                        '523': true,
                        '524': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 10.958 + labelYOffset, -155)
                    }
                },
                3: {
                    obj: 'NOVA_3NP',
                    objPlan: 'NOVA_3NP-pudorys',
                    targetY: 14.128 + targetYOffset,
                    flats: {
                        '131': true,
                        '132': true,
                        '133': true,
                        '134': true,
                        '231': true,
                        '232': true,
                        '233': true,
                        '234': true,
                        '235': true,
                        '331': true,
                        '332': true,
                        '333': true,
                        '334': true,
                        '335': true,
                        '431': true,
                        '432': true,
                        '433': true,
                        '434': true,
                        '435': true,
                        '436': true,
                        '531': true,
                        '532': true,
                        '533': true,
                        '534': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 14.128 + labelYOffset, -155)
                    }
                },
                4: {
                    obj: 'NOVA_4NP',
                    objPlan: 'NOVA_4NP-pudorys',
                    targetY: 17.309 + targetYOffset,
                    flats: {
                        '141': true,
                        '142': true,
                        '143': true,
                        '144': true,
                        '241': true,
                        '242': true,
                        '243': true,
                        '244': true,
                        '245': true,
                        '341': true,
                        '342': true,
                        '343': true,
                        '344': true,
                        '345': true,
                        '441': true,
                        '442': true,
                        '443': true,
                        '444': true,
                        '445': true,
                        '446': true,
                        '541': true,
                        '542': true,
                        '543': true,
                        '544': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 17.309 + labelYOffset, -155)
                    }
                },
                5: {
                    obj: 'NOVA_5NP',
                    objPlan: 'NOVA_5NP-pudorys',
                    targetY: 20.489 + targetYOffset,
                    flats: {
                        '151': true,
                        '152': true,
                        '153': true,
                        '154': true,
                        '251': true,
                        '252': true,
                        '253': true,
                        '254': true,
                        '255': true,
                        '351': true,
                        '352': true,
                        '353': true,
                        '354': true,
                        '355': true,
                        '451': true,
                        '452': true,
                        '453': true,
                        '454': true,
                        '455': true,
                        '456': true,
                        '551': true,
                        '552': true,
                        '553': true,
                        '554': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 20.489 + labelYOffset, -155)
                    }
                },
                6: {
                    obj: 'NOVA_6NP',
                    objPlan: 'NOVA_6NP-pudorys',
                    targetY: 23.675 + targetYOffset,
                    flats: {
                        '161': true,
                        '162': true,
                        '163': true,
                        '164': true,
                        '261': true,
                        '262': true,
                        '263': true,
                        '264': true,
                        '265': true,
                        '361': true,
                        '362': true,
                        '363': true,
                        '364': true,
                        '365': true,
                        '461': true,
                        '462': true,
                        '463': true,
                        '464': true,
                        '465': true,
                        '466': true,
                        '561': true,
                        '562': true,
                        '563': true,
                        '564': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 23.675 + labelYOffset, -155)
                    }
                },
                7: {
                    obj: 'NOVA_7NP',
                    objPlan: 'NOVA_7NP-pudorys',
                    targetY: 27.067 + targetYOffset,
                    flats: {
                        '171': true,
                        '172': true,
                        '271': true,
                        '272': true,
                        '371': true,
                        '372': true,
                        '471': true,
                        '472': true,
                        '473': true,
                        '571': true,
                        '572': true,
                        '573': true
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 27.067 + labelYOffset, -155)
                    }
                },
                8: {
                    obj: 'NOVA_8NP',
                    objPlan: 'NOVA_8NP-pudorys',
                    targetY: 30.444 + targetYOffset,
                    flats: {
                        '181': true,
                        '281': true,
                        '381': true,
                        '481': true,
                        '581': true,
                        '582': true,
                        '583': true,
                        '584': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 30.444 + labelYOffset, -155)
                    }
                },
                9: {
                    obj: 'NOVA_9NP',
                    objPlan: 'NOVA_9NP-pudorys',
                    targetY: 33.633 + targetYOffset,
                    flats: {
                        '591': true,
                        '592': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 33.633 + labelYOffset, -155)
                    }
                },
                10: {
                    obj: 'NOVA_10NP',
                    objPlan: 'NOVA_10NP-pudorys',
                    targetY: 37.014 + targetYOffset,
                    flats: {
                        '5101': true,
                    },
                    commerces: {},
                    label: {
                        position: new THREE.Vector3(-195, 37.014 + labelYOffset, -155)
                    }
                }
            }
        };
    }

    /**
     * @protected
     */
    _initScene() {
        super._initScene();

        // points of interrests
        this.points = new PointsBuilding(this.container, this.camera, this.controls, this.objects);
    }

    /**
     * @protected
     */
    _initGeometry() {
        let filesCount = 0;
        for (let name in FILES) {
            filesCount++;
        }
        for (let name in FILES_PLANS) {
            filesCount++;
        }
        this.loader.setProgress(filesCount);

        super._initGeometry();

        // půdorysy pater
        for (let name in FILES_PLANS) {
            this._loadModelPlan(FILES_PLANS[name], name);
        }

        // plocha reprezentující podložku pod modelem (dopadá na ní stín budovy)
        let plane = new THREE.Mesh(
            new THREE.PlaneGeometry(4000, 4000, 1, 1),
            new THREE.MeshPhongMaterial({
                color: 0xe9e9e9
            })
        );
        plane.name = 'ground';
        plane.translateX(-180);
        // plane.translateY(3.056);
        plane.translateZ(-160);
        plane.rotateX(-Math.PI / 2);
        plane.rotateZ(0.37);
        plane.castShadow = false;
        plane.receiveShadow = true;
        this.scene.add(plane);

        // grid
        // let grid = new THREE.GridHelper(2500, 250, 0x202020, 0x888888);
        // grid.translateY(15);
        // this.scene.add(grid);
    }

    /**
     * @protected
     */
    _initDOM() {
        super._initDOM();

        // tlačítka pro překliknutí patra
        let btns = document.getElementsByClassName('btn-floor');
        for (let i = 0; i < btns.length; ++i) {
            let btn = btns[i];
            this.floorBtns[btn.dataset.floor] = btn;
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: načtení modelů

    /**
     * @param {string} url
     * @param {string} name
     *
     * @protected
     */
    _loadModelPlan(url, name) {
        this.loadedModels[name] = false;

        let loader = new THREE.GLTFLoader();
        loader.load(
            url,
            this._callbackModelPlanLoaded.bind(this, name),
            function(xhr) {},
            this._callbackModelNotLoaded.bind(this, name)
        );
    }

    /**
     * @param {string} name
     * @param {Object} gltf
     *
     * @protected
     */
    _callbackModelPlanLoaded(name, gltf) {
        let floorOpt = null;
        this._traverseBuildingFloorsOpt((floorNo, opt) => {
            if (opt.objPlan === name) {
                floorOpt = opt;
            }
        });

        if (!floorOpt) {
            console.log(`půdorysu '${name}' neodpovídá žádné patro`);
            this.loadedModels[name] = true;
            this.loader.updateProgress();
            return;
        }

        let object = gltf.scene;
        object.scale.set(this.opt.geometry.scale, this.opt.geometry.scale, this.opt.geometry.scale);

        let obj = new ObjPlan(name, object, true);
        obj.hide();
        obj.setCard(new CardFlat(this.container, this.camera));
        obj.setOpt(floorOpt);
        this.objects.add(obj);

        this.loadedModels[name] = true;
        if (this._checkAllModelsLoaded()) {
            this._callbackAllModelsLoaded();
        }

        this.loader.updateProgress();
    }

    /**
     * @param {string} name
     * @param {Object} gltf
     *
     * @protected
     */
    _callbackModelLoaded(name, gltf) {
        let object = gltf.scene;
        object.scale.set(this.opt.geometry.scale, this.opt.geometry.scale, this.opt.geometry.scale);

        let obj = new ObjModelFloor(name, object, this._isPickable(name));
        this.objects.add(obj);

        this.loadedModels[name] = true;
        if (this._checkAllModelsLoaded()) {
            this._callbackAllModelsLoaded();
        }

        this.loader.updateProgress();
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private

    /**
     * @param {function(floorNo: number, opt: {})} callback
     *
     * @private
     */
    _traverseBuildingFloorsOpt(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        for (let floorNo in this.opt.building.floors) {
            if (this.opt.building.floors.hasOwnProperty(floorNo)) {
                callback(Number(floorNo), this.opt.building.floors[floorNo]);
            }
        }
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // private: callbacks

    /**
     * Callback události: všechny modely nahrány
     *
     * @protected
     */
    _callbackAllModelsLoaded() {
        this.building = new Building(this.animations, this.camera, this.controls, this.floorBtns);
        this._traverseBuildingFloorsOpt((floorNo, opt) => {
            let obj = this.objects.getObj(opt.obj);
            if (obj) {
                obj.setCard(
                    new CardFloor(this.container, this.camera, floorNo)
                );
                obj.setCardStatic(
                    new CardFloorStatic(this.container, this.camera, this.controls, floorNo, opt.label.position)
                );
                let objPlan = this.objects.getObj(opt.objPlan);
                this.building.addFloor(
                    new Floor(floorNo, obj, objPlan, opt)
                );
            }
        });

        super._callbackAllModelsLoaded();
    }

    /**
     * Callback události: vybrán objekt
     *
     * @param {Obj} obj
     *
     * @protected
     */
    _callbackObjSelected(obj) {
        this._traverseBuildingFloorsOpt((floorNo, opt) => {
            if (opt.obj === obj.name) {
                this.building.activateFloor(floorNo, obj.state);
            }
        });
    }
}